export default [
  {
    code: 1721,
    name: 'Painting and Paper Hanging (traffic lane painting)',
  },
  {
    code: 2041,
    name: 'Flour and Other Grain Mill Products',
  },
  {
    code: 2043,
    name: 'Cereal Breakfast Foods (cereal breakfast foods and related preparations except grain based coffee substitutes)',
  },
  {
    code: 2044,
    name: 'Rice Milling',
  },
  {
    code: 2045,
    name: 'Prepared Flour Mixes and Doughs',
  },
  {
    code: 2046,
    name: 'Wet Corn Milling (except refining purchased corn oil)',
  },
  {
    code: 2047,
    name: 'Dog and Cat Food',
  },
  {
    code: 2048,
    name: 'Prepared Feeds and Feed Ingredients for Animals and Fowls, Except Dogs and Cats (except slaughtering animals for pet food)',
  },
  {
    code: 2051,
    name: 'Bread and Other Bakery Products, Except Cookies and Crackers',
  },
  {
    code: 2052,
    name: 'Cookies and Crackers (unleavened bread and soft pretzels)',
  },
  {
    code: 2053,
    name: 'Frozen Bakery Products, Except Bread',
  },
  {
    code: 2061,
    name: 'Cane Sugar, Except Refining',
  },
  {
    code: 2062,
    name: 'Cane Sugar Refining',
  },
  {
    code: 2063,
    name: 'Beet Sugar',
  },
  {
    code: 2064,
    name: 'Candy and Other Confectionery Products (chocolate confectionery)',
  },
  {
    code: 2066,
    name: 'Chocolate and Cocoa Products (except chocolate products, made from purchased chocolate)',
  },
  {
    code: 2067,
    name: 'Chewing Gum',
  },
  {
    code: 2068,
    name: 'Salted and Roasted Nuts and Seeds',
  },
  {
    code: 2074,
    name: 'Cottonseed Oil Mills (cottonseed processing)',
  },
  {
    code: 2075,
    name: 'Soybean Oil Mills (soybean processing, except edible soybean oil)',
  },
  {
    code: 2076,
    name: 'Vegetable Oil Mills, Except Corn, Cottonseed, and Soybean (oilseed processing)',
  },
  {
    code: 2077,
    name: 'Animal and Marine Fats and Oils (animal fats and oils)',
  },
  {
    code: 2079,
    name: 'Shortening, Table Oils, Margarine, and Other Edible Fats and Oils, NEC (processing soybean oil into edible cooking oils from soybeans crushed in the same establishment)',
  },
  {
    code: 2082,
    name: 'Malt Beverages (malt extract)',
  },
  {
    code: 2083,
    name: 'Malt',
  },
  {
    code: 2084,
    name: 'Wines, Brandy, and Brandy Spirits',
  },
  {
    code: 2085,
    name: 'Distilled and Blended Liquors (apple jack)',
  },
  {
    code: 2086,
    name: 'Bottled and Canned Soft Drinks and Carbonated Water (except bottled water)',
  },
  {
    code: 2087,
    name: 'Flavoring Extracts and Flavoring Syrups, NEC (coffee flavoring and syrups)',
  },
  {
    code: 2091,
    name: 'Canned and Cured Fish and Seafoods',
  },
  {
    code: 2092,
    name: 'Prepared Fresh or Frozen Fish and Seafoods',
  },
  {
    code: 2095,
    name: 'Roasted Coffee',
  },
  {
    code: 2096,
    name: 'Potato Chips, Corn Chips, and Similar Snacks',
  },
  {
    code: 2097,
    name: 'Manufactured Ice',
  },
  {
    code: 2098,
    name: 'Macaroni, Spaghetti, Vermicelli and Noodles',
  },
  {
    code: 2099,
    name: 'Food Preparations, NEC (reducing maple sap to maple syrup)',
  },
  {
    code: 2111,
    name: 'Cigarettes',
  },
  {
    code: 2121,
    name: 'Cigars',
  },
  {
    code: 2131,
    name: 'Chewing and Smoking Tobacco and Snuff',
  },
  {
    code: 2141,
    name: 'Tobacco Stemming and Redrying (stemming and redrying tobacco)',
  },
  {
    code: 2211,
    name: 'Broadwoven Fabric Mills, Cotton',
  },
  {
    code: 2221,
    name: 'Broadwoven Fabric Mills, Manmade Fiber and Silk',
  },
  {
    code: 2231,
    name: 'Broadwoven Fabric Mills, Wool (Including Dyeing and Finishing) (except finishing wool fabric without weaving wool fabric)',
  },
  {
    code: 2241,
    name: 'Narrow Fabric and Other Smallware Mills: Cotton, Wool, Silk and Manmade Fiber',
  },
  {
    code: 2251,
    name: 'Women’s Full-Length and Knee-Length Hosiery, Except Socks (dyeing and finishing sheer hosiery without knitting sheer hosiery)',
  },
  {
    code: 2252,
    name: 'Hosiery, NEC (dyeing and finishing hosiery , except sheer, without knitting hosiery)',
  },
  {
    code: 2253,
    name: 'Knit Outerwear Mills (dyeing and finishing knit outerwear without knitting outerwear)',
  },
  {
    code: 2254,
    name: 'Knit Underwear and Nightwear Mills (dyeing and finishing underwear and nightwear without knitting garments)',
  },
  {
    code: 2257,
    name: 'Weft Knit Fabric Mills (except finishing without knitting weft fabric)',
  },
  {
    code: 2258,
    name: 'Lace and Warp Knit Fabric Mills (except finishing lace or warp fabric without knitting lace or warp fabric)',
  },
  {
    code: 2259,
    name: 'Knitting Mills, NEC (knitting weft fabric and fabricating textile products, such as bedspreads, curtains, or towels)',
  },
  {
    code: 2261,
    name: 'Finishers of Broadwoven Fabrics of Cotton',
  },
  {
    code: 2262,
    name: 'Finishers of Broadwoven Fabrics of Manmade Fiber and Silk',
  },
  {
    code: 2269,
    name: 'Finishers of Textiles, NEC (linen fabric finishing)',
  },
  {
    code: 2273,
    name: 'Carpets and Rugs',
  },
  {
    code: 2281,
    name: 'Yarn Spinning Mills',
  },
  {
    code: 2282,
    name: 'Yarn Texturizing, Throwing, Twisting and Winding Mills ',
  },
  {
    code: 2284,
    name: 'Thread Mills (except finishing thread without manufacturing thread)',
  },
  {
    code: 2295,
    name: 'Coated Fabrics, Not Rubberized',
  },
  {
    code: 2296,
    name: 'Tire Cord and Fabrics',
  },
  {
    code: 2297,
    name: 'Nonwoven Fabrics',
  },
  {
    code: 2298,
    name: 'Cordage and Twine (hemp rope made in spinning mills)',
  },
  {
    code: 2299,
    name: 'Textile Goods, NEC (hemp bags made in spinning mills)',
  },
  {
    code: 2311,
    name: 'Men’s and Boys’ Suits, Coats, and Overcoats (contractors)',
  },
  {
    code: 2321,
    name: 'Men’s and Boys’ Shirts, Except Work Shirts (contractors)',
  },
  {
    code: 2322,
    name: 'Men’s and Boys’ Underwear and Nightwear (contractors)',
  },
  {
    code: 2323,
    name: "Men's and Boys' Neckwear (contractors)",
  },
  {
    code: 2325,
    name: 'Men’s and Boys’ Separate Trousers and Slacks (contractors)',
  },
  {
    code: 2326,
    name: 'Men’s and Boys’ Work Clothing (contractors)',
  },
  {
    code: 2329,
    name: 'Men’s and Boys’ Clothing, NEC (contractors)',
  },
  {
    code: 2331,
    name: 'Women’s, Misses’, and Juniors’ Blouses and Shirts (contractors)',
  },
  {
    code: 2335,
    name: 'Women’s, Misses’, and Juniors’ Dresses (contractors)',
  },
  {
    code: 2337,
    name: 'Women’s, Misses’, and Juniors’ Suits, Skirts, and Coats (contractors)',
  },
  {
    code: 2339,
    name: 'Women’s, Misses’, and Juniors’ Outerwear, NEC (contractors)',
  },
  {
    code: 2341,
    name: 'Women’s, Misses’, Children’s, and Infants’ Underwear and Nightwear (boys’ contractors)',
  },
  {
    code: 2342,
    name: 'Brassieres, Girdles, and Allied Garments (contractors)',
  },
  {
    code: 2353,
    name: "Hats, Caps, and Millinery (men's and boys' contractors)",
  },
  {
    code: 2361,
    name: 'Girls’, Children’s, and Infants’ Dresses, Blouses, and Shirts (boys’ contractors)',
  },
  {
    code: 2369,
    name: 'Girls’, Children’s, and Infants’ Outerwear, NEC (boys’ contractors)',
  },
  {
    code: 2371,
    name: "Fur Goods (men's and boys' contractors)",
  },
  {
    code: 2381,
    name: "Dress and Work Gloves, Except Knit and All-Leather (men's and boys' contractors)",
  },
  {
    code: 2384,
    name: 'Robes and Dressing Gowns (men’s and boys’ contractors)',
  },
  {
    code: 2385,
    name: "Waterproof Outerwear (men’s and boys' contractors)",
  },
  {
    code: 2386,
    name: "Leather and Sheep-Lined Clothing (men's and boys' contractors)",
  },
  {
    code: 2387,
    name: "Apparel Belts (men's and boys' contractors)",
  },
  {
    code: 2389,
    name: "Apparel and Accessories, NEC (men's and boys' contractors)",
  },
  {
    code: 2391,
    name: 'Curtains and Draperies',
  },
  {
    code: 2392,
    name: 'Housefurnishings, Except Curtains and Draperies (except mops, dust rags, and bags)',
  },
  {
    code: 2393,
    name: 'Textile Bags',
  },
  {
    code: 2394,
    name: 'Canvas and Related Products',
  },
  {
    code: 2395,
    name: 'Pleating, Decorative and Novelty Stitching, and Tucking for the Trade (except apparel contractors)',
  },
  {
    code: 2396,
    name: 'Automotive Trimmings, Apparel Findings, and Related Products (textile products except automotive and apparel trimmings and findings, printing or embossing on apparel, and contractors)',
  },
  {
    code: 2397,
    name: 'Schiffli Machine Embroideries',
  },
  {
    code: 2399,
    name: 'Fabricated Textile Products, NEC (except apparel and accessories, automotive seat belts, seat and tire covers, and contractors)',
  },
  {
    code: 2511,
    name: 'Wood Household Furniture, Except Upholstered (except wood box spring frames)',
  },
  {
    code: 2512,
    name: 'Wood Household Furniture, Upholstered',
  },
  {
    code: 2514,
    name: 'Metal Household Furniture (upholstered)',
  },
  {
    code: 2515,
    name: 'Mattresses, Foundations, and Convertible Beds (convertible beds)',
  },
  {
    code: 2517,
    name: 'Wood Television, Radio, Phonograph, and Sewing Machine Cabinets',
  },
  {
    code: 2519,
    name: 'Household Furniture, NEC',
  },
  {
    code: 2521,
    name: 'Wood Office Furniture',
  },
  {
    code: 2522,
    name: 'Office Furniture, Except Wood',
  },
  {
    code: 2531,
    name: 'Public Building and Related Furniture (seats for motor vehicles)',
  },
  {
    code: 2541,
    name: 'Wood Office and Store Fixtures, Partitions, Shelving, and Lockers (counter tops)',
  },
  {
    code: 2542,
    name: 'Office and Store Fixtures, Partitions, Shelving, and Lockers, Except Wood (lunchroom tables and chairs)',
  },
  {
    code: 2591,
    name: 'Drapery Hardware and Window Blinds and Shades',
  },
  {
    code: 2599,
    name: 'Furniture and Fixtures, NEC (except hospital beds)',
  },
  {
    code: 2611,
    name: 'Pulp Mills (pulp producing mills only)',
  },
  {
    code: 2621,
    name: 'Paper Mills (except newsprint mills)',
  },
  {
    code: 2631,
    name: 'Paperboard Mills',
  },
  {
    code: 2652,
    name: 'Setup Paperboard Boxes',
  },
  {
    code: 2653,
    name: 'Corrugated and Solid Fiber Boxes',
  },
  {
    code: 2655,
    name: 'Fiber Cans, Tubes, Drums, and Similar Products',
  },
  {
    code: 2656,
    name: 'Sanitary Food Containers, Except Folding',
  },
  {
    code: 2657,
    name: 'Folding Paperboard Boxes, Including Sanitary (except paperboard backs for blister or skin packages)',
  },
  {
    code: 2671,
    name: 'Packaging Paper and Plastics Film, Coated and Laminated (except single-web and multi-web plastics packaging film and sheet)',
  },
  {
    code: 2672,
    name: 'Coated and Laminated Paper, NEC',
  },
  {
    code: 2673,
    name: 'Plastics, Foil, and Coated Paper Bags (except single web or multi-web plastic bags)',
  },
  {
    code: 2674,
    name: 'Uncoated Paper and Multiwall Bags',
  },
  {
    code: 2675,
    name: 'Die-Cut Paper and Paperboard and Cardboard (pasted, lined, laminated, or surface-coated paperboard)',
  },
  {
    code: 2676,
    name: 'Sanitary Paper Products',
  },
  {
    code: 2677,
    name: 'Envelopes',
  },
  {
    code: 2678,
    name: 'Stationery, Tablets, and Related Products',
  },
  {
    code: 2679,
    name: 'Converted Paper and Paperboard Products, NEC (corrugated paper)',
  },
  {
    code: 2711,
    name: 'Newspapers: Publishing, or Publishing and Printing (except Internet newspaper publishing)',
  },
  {
    code: 2721,
    name: 'Periodicals: Publishing, or Publishing and Printing (except Internet periodical publishing)',
  },
  {
    code: 2731,
    name: 'Books: Publishing, or Publishing and Printing (except music books and Internet book publishing)',
  },
  {
    code: 2732,
    name: 'Book Printing',
  },
  {
    code: 2741,
    name: 'Miscellaneous Publishing (shopping news and advertising periodical publishing or publishing and printing except Internet)',
  },
  {
    code: 2752,
    name: 'Commercial Printing, Lithographic (except quick printing)',
  },
  {
    code: 2754,
    name: 'Commercial Printing, Gravure',
  },
  {
    code: 2759,
    name: 'Commercial Printing, NEC (flexographic printing)',
  },
  {
    code: 2761,
    name: 'Manifold Business Forms',
  },
  {
    code: 2771,
    name: 'Greeting Cards (lithographic printing of greeting cards)',
  },
  {
    code: 2782,
    name: 'Blankbooks, Looseleaf Binders and Devices (checkbooks)',
  },
  {
    code: 2789,
    name: 'Bookbinding and Related Work',
  },
  {
    code: 2791,
    name: 'Typesetting',
  },
  {
    code: 2796,
    name: 'Platemaking and Related Services',
  },
  {
    code: 2824,
    name: 'Manmade Organic Fibers, Except Cellulosic',
  },
  {
    code: 2833,
    name: 'Medicinal Chemicals and Botanical Products',
  },
  {
    code: 2834,
    name: 'Pharmaceutical Preparations ',
  },
  {
    code: 2835,
    name: 'In Vitro and In Vivo Diagnostic Substances (except in-vitro diagnostic substances)',
  },
  {
    code: 2836,
    name: 'Biological Products, Except Diagnostic Substances',
  },
  {
    code: 2841,
    name: 'Soaps and Other Detergents, Except Specialty Cleaners',
  },
  {
    code: 2842,
    name: 'Specialty Cleaning, Polishing, and Sanitation Preparations',
  },
  {
    code: 2843,
    name: 'Surface Active Agents, Finishing Agents, Sulfonated Oils, and Assistants',
  },
  {
    code: 2844,
    name: 'Perfumes, Cosmetics, and Other Toilet Preparations (toothpaste, gel, and dentifrice powders)',
  },
  {
    code: 2851,
    name: 'Paints, Varnishes, Lacquers, Enamels and Allied Products',
  },
  {
    code: 2861,
    name: 'Gum and Wood Chemicals',
  },
  {
    code: 3131,
    name: 'Boot and Shoe Cut Stock and Findings (except wood heels and metal buckles)',
  },
  {
    code: 3142,
    name: 'House Slippers',
  },
  {
    code: 3143,
    name: 'Men’s Footwear, Except Athletic',
  },
  {
    code: 3144,
    name: 'Women’s Footwear, Except Athletic',
  },
  {
    code: 3149,
    name: 'Footwear,  Except Rubber, NEC',
  },
  {
    code: 3151,
    name: "Leather Gloves and Mittens (men's and boys' contractors)",
  },
  {
    code: 3161,
    name: 'Luggage',
  },
  {
    code: 3171,
    name: 'Women’s Handbags and Purses',
  },
  {
    code: 3172,
    name: 'Personal Leather Goods, Except Women’s Handbags and Purses (except nonprecious metal personal goods, such as card cases, cigar cases, and comb cases)',
  },
  {
    code: 3199,
    name: 'Leather Goods, NEC',
  },
  {
    code: 3411,
    name: 'Metal Cans',
  },
  {
    code: 3412,
    name: 'Metal Shipping Barrels, Drums, Kegs, and Pails',
  },
  {
    code: 3421,
    name: "Cutlery (except hedge shears and trimmers, tinners' snips, and similar nonelectric hand tools)",
  },
  {
    code: 3423,
    name: 'Hand and Edge Tools, Except Machine Tools and Handsaws',
  },
  {
    code: 3425,
    name: 'Saw Blades and Handsaws',
  },
  {
    code: 3429,
    name: 'Hardware, NEC (vacuum and insulated bottles, jugs, and chests)',
  },
  {
    code: 3431,
    name: 'Enameled Iron and Metal Sanitary Ware',
  },
  {
    code: 3432,
    name: 'Plumbing Fixture Fittings and Trim (except shower rods, lawn hose nozzles, and lawn sprinklers)',
  },
  {
    code: 3433,
    name: 'Heating Equipment, Except Electric and Warm Air Furnaces',
  },
  {
    code: 3571,
    name: 'Electronic Computers',
  },
  {
    code: 3572,
    name: 'Computer Storage Devices',
  },
  {
    code: 3575,
    name: 'Computer Terminals',
  },
  {
    code: 3577,
    name: 'Computer Peripheral Equipment, NEC (except plotter controllers and magnetic tape head cleaners)',
  },
  {
    code: 3578,
    name: 'Calculating and Accounting Machinery, Except Electronic Computers (change making machines)',
  },
  {
    code: 3579,
    name: 'Office Machines, NEC (except timeclocks, time stamps, pencil sharpeners, stapling machines, etc.)',
  },
  {
    code: 3581,
    name: 'Automatic Vending Machines',
  },
  {
    code: 3582,
    name: 'Commercial Laundry, Drycleaning, and Pressing Machines',
  },
  {
    code: 3585,
    name: 'Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment (except motor vehicle air-conditioning)',
  },
  {
    code: 3586,
    name: 'Measuring and Dispensing Pumps',
  },
  {
    code: 3589,
    name: 'Service Industry Machinery, NEC',
  },
  {
    code: 3592,
    name: 'Carburetors, Pistons, Piston Rings, and Valves',
  },
  {
    code: 3593,
    name: 'Fluid Power Cylinders and Actuators',
  },
  {
    code: 3594,
    name: 'Fluid Power Pumps and Motors',
  },
  {
    code: 3596,
    name: 'Scales and Balances, Except Laboratory',
  },
  {
    code: 3599,
    name: 'Industrial and Commercial Machinery and Equipment, NEC (machine shops)',
  },
  {
    code: 3612,
    name: 'Power, Distribution, and Specialty Transformers',
  },
  {
    code: 3613,
    name: 'Switchgear and Switchboard Apparatus',
  },
  {
    code: 3621,
    name: 'Motors and Generators',
  },
  {
    code: 3624,
    name: 'Carbon and Graphite Products ',
  },
  {
    code: 3625,
    name: 'Relays and Industrial Controls',
  },
  {
    code: 3629,
    name: 'Electrical Industrial Apparatus, NEC',
  },
  {
    code: 3631,
    name: 'Household Cooking Equipment',
  },
  {
    code: 3632,
    name: 'Household Refrigerators and Home and Farm Freezers',
  },
  {
    code: 3633,
    name: 'Household Laundry Equipment',
  },
  {
    code: 3634,
    name: 'Electric Housewares and Fans (wall and baseboard heating units for permanent installation)',
  },
  {
    code: 3635,
    name: 'Household Vacuum Cleaners',
  },
  {
    code: 3639,
    name: 'Household Appliances, NEC (household sewing machines)',
  },
  {
    code: 3641,
    name: 'Electric Lamp Bulbs and Tubes',
  },
  {
    code: 3643,
    name: 'Current-Carrying Wiring Devices',
  },
  {
    code: 3644,
    name: 'Noncurrent-Carrying Wiring Devices (fish wire, electrical wiring tool)',
  },
  {
    code: 3645,
    name: 'Residential Electric Lighting Fixtures',
  },
  {
    code: 3646,
    name: 'Commercial, Industrial, and Institutional Electric Lighting Fixtures',
  },
  {
    code: 3647,
    name: 'Vehicular Lighting Equipment',
  },
  {
    code: 3648,
    name: 'Lighting Equipment, NEC',
  },
  {
    code: 3651,
    name: 'Household Audio and Video Equipment',
  },
  {
    code: 3652,
    name: 'Phonograph Records and Prerecorded Audio Tapes and Disks (reproduction of all other media except video)',
  },
  {
    code: 3661,
    name: 'Telephone and Telegraph Apparatus (except consumer external modems)',
  },
  {
    code: 3663,
    name: 'Radio and Television Broadcasting and Communications Equipment',
  },
  {
    code: 3669,
    name: 'Communications Equipment, NEC',
  },
  {
    code: 3671,
    name: 'Electron Tubes',
  },
  {
    code: 3672,
    name: 'Printed Circuit Boards',
  },
  {
    code: 3674,
    name: 'Semiconductors and Related Devices',
  },
  {
    code: 3675,
    name: 'Electronic Capacitors',
  },
  {
    code: 3676,
    name: 'Electronic Resistors',
  },
  {
    code: 3677,
    name: 'Electronic Coils, Transformers, and Other Inductors',
  },
  {
    code: 3678,
    name: 'Electronic Connectors',
  },
  {
    code: 3679,
    name: 'Electronic Components, NEC (antennas)',
  },
  {
    code: 3691,
    name: 'Storage Batteries',
  },
  {
    code: 3692,
    name: 'Primary Batteries, Dry and Wet',
  },
  {
    code: 3694,
    name: 'Electrical Equipment for Internal Combustion Engines',
  },
  {
    code: 3695,
    name: 'Magnetic and Optical Recording Media',
  },
  {
    code: 3699,
    name: 'Electrical Machinery, Equipment, and Supplies, NEC (electronic teaching machines and flight simulators)',
  },
  {
    code: 3711,
    name: 'Motor Vehicles and Passenger Car Bodies (automobiles)',
  },
  {
    code: 3713,
    name: 'Truck and Bus Bodies',
  },
  {
    code: 3714,
    name: 'Motor Vehicle Parts and Accessories (dump truck lifting mechanisms and fifth wheels)',
  },
  {
    code: 3715,
    name: 'Truck Trailers',
  },
  {
    code: 3716,
    name: 'Motor Homes',
  },
  {
    code: 3721,
    name: 'Aircraft (except research and development not producing prototypes)',
  },
  {
    code: 3724,
    name: 'Aircraft Engines and Engine Parts (except research and development not producing prototypes)',
  },
  {
    code: 3728,
    name: 'Aircraft Parts and Auxiliary Equipment, NEC (fluid power aircraft subassemblies)',
  },
  {
    code: 3731,
    name: 'Ship Building and Repairing (except repairs in floating drydocks)',
  },
  {
    code: 3732,
    name: 'Boat Building and Repairing (boat building)',
  },
  {
    code: 3743,
    name: 'Railroad Equipment (locomotive fuel lubricating or cooling medium pumps)',
  },
  {
    code: 3751,
    name: 'Motorcycles, Bicycles, and Parts',
  },
  {
    code: 3792,
    name: 'Travel Trailers and Campers',
  },
  {
    code: 3795,
    name: 'Tanks and Tank Components',
  },
  {
    code: 3799,
    name: 'Transportation Equipment, NEC (wheelbarrows)',
  },
  {
    code: 3812,
    name: 'Search, Detection, Navigation, Guidance, Aeronautical, and Nautical Systems and Instruments',
  },
  {
    code: 3821,
    name: 'Laboratory Apparatus and Furniture',
  },
  {
    code: 3822,
    name: 'Automatic Controls for Regulating Residential and Commercial Environments and Appliances',
  },
  {
    code: 3823,
    name: 'Industrial Instruments for Measurement, Display, and Control of Process Variables; and Related Products',
  },
  {
    code: 3824,
    name: 'Totalizing Fluid Meters and Counting Devices',
  },
  {
    code: 3825,
    name: 'Instruments for Measuring and Testing of Electricity and Electrical Signals (automotive ammeters and voltmeters)',
  },
  {
    code: 3826,
    name: 'Laboratory Analytical Instruments',
  },
  {
    code: 3827,
    name: 'Optical Instruments and Lenses',
  },
  {
    code: 3829,
    name: 'Measuring and Controlling Devices, NEC (motor vehicle gauges)',
  },
  {
    code: 3841,
    name: 'Surgical and Medical Instruments and Apparatus (tranquilizer guns)',
  },
  {
    code: 3842,
    name: 'Orthopedic, Prosthetic, and Surgical Appliances and Supplies (incontinent pads and bed pads)',
  },
  {
    code: 3843,
    name: 'Dental Equipment and Supplies',
  },
  {
    code: 3844,
    name: 'X-Ray Apparatus and Tubes and Related Irradiation Apparatus',
  },
  {
    code: 3845,
    name: 'Electromedical and Electrotherapeutic Apparatus (except CT and CAT scanners)',
  },
  {
    code: 3851,
    name: 'Ophthalmic Goods (intraoccular lenses, i.e., surgical implants)',
  },
  {
    code: 3861,
    name: 'Photographic Equipment and Supplies (photographic films, paper, plates and chemicals)',
  },
  {
    code: 3873,
    name: 'Watches, Clocks, Clockwork Operated Devices, and Parts',
  },
  {
    code: 3911,
    name: 'Jewelry, Precious Metal',
  },
  {
    code: 3914,
    name: 'Silverware, Plated Ware, and Stainless Steel Ware (cutlery and flatware, nonprecious and precious plated)',
  },
  {
    code: 3915,
    name: 'Jewelers Findings and Materials and Lapidary Work (watch jewels)',
  },
  {
    code: 3931,
    name: 'Musical Instruments',
  },
  {
    code: 3942,
    name: 'Dolls and Stuffed Toys',
  },
  {
    code: 3944,
    name: 'Games, Toys, and Children’s Vehicles, Except Dolls and Bicycles (metal tricycles)',
  },
  {
    code: 3949,
    name: 'Sporting and Athletic Goods, NEC',
  },
  {
    code: 3951,
    name: 'Pens, Mechanical Pencils, and Parts ',
  },
  {
    code: 3952,
    name: 'Lead Pencils and Art Goods (drawing inks and india ink)',
  },
  {
    code: 3953,
    name: 'Marking Devices',
  },
  {
    code: 3955,
    name: 'Carbon Paper and Inked Ribbons',
  },
  {
    code: 3961,
    name: 'Costume Jewelry and Costume Novelties, Except Precious Metal (except cuff links)',
  },
  {
    code: 3965,
    name: 'Fasteners, Buttons, Needles, and Pins',
  },
  {
    code: 3991,
    name: 'Brooms and Brushes',
  },
  {
    code: 3993,
    name: 'Signs and Advertising Specialties (screen printing purchased advertising specialties)',
  },
  {
    code: 3995,
    name: 'Burial Caskets',
  },
  {
    code: 3996,
    name: 'Linoleum, Asphalted-Felt-Base, and Other Hard Surface Floor Coverings, NEC',
  },
  {
    code: 4724,
    name: 'Travel Agencies',
  },
  {
    code: 4725,
    name: 'Tour Operators',
  },
  {
    code: 4729,
    name: 'Arrangement of Passenger Transportation, NEC (arrangement of carpools and vanpools)',
  },
  {
    code: 4731,
    name: 'Arrangement of Transportation of Freight and Cargo (except freight rate auditors, private mail centers, and tariff consultants)',
  },
  {
    code: 4741,
    name: 'Rental of Railroad Cars (grain leveling in railroad cars, grain trimming for railroad equipment, precooling of fruits and vegetables in connection with transportation, and railroad car cleaning, icing, ventilating, and heating)',
  },
  {
    code: 4783,
    name: 'Packing and Crating',
  },
  {
    code: 4785,
    name: 'Fixed Facilities and Inspection and Weighing Services for Motor Vehicle Transportation (marine cargo checkers)',
  },
  {
    code: 4789,
    name: 'Transportation Services, NEC (horse-drawn cabs and carriages)',
  },
  {
    code: 4812,
    name: 'Radiotelephone Communications (paging carriers)',
  },
  {
    code: 4813,
    name: 'Telephone Communications, Except Radiotelephone (except resellers)',
  },
  {
    code: 4822,
    name: 'Telegraph and Other Message Communications',
  },
  {
    code: 4832,
    name: 'Radio Broadcasting Stations (networks)',
  },
  {
    code: 4833,
    name: 'Television Broadcasting Stations ',
  },
  {
    code: 4841,
    name: 'Cable and Other Pay Television Services (cable networks)',
  },
  {
    code: 4899,
    name: 'Communications Services, NEC (radio broadcasting operated by cab companies)',
  },
  {
    code: 4939,
    name: 'Combination Utilities, NEC (hydroelectric power generation)',
  },
  {
    code: 4941,
    name: 'Water Supply',
  },
  {
    code: 5012,
    name: 'Automobiles and Other Motor Vehicles (merchant wholesalers)',
  },
  {
    code: 5013,
    name: 'Motor Vehicle Supplies and New Parts (merchant wholesalers except those selling via retail method) ',
  },
  {
    code: 5014,
    name: 'Tires and Tubes (merchant wholesalers except those selling via retail method)',
  },
  {
    code: 5015,
    name: 'Motor Vehicle Parts, Used (merchant wholesalers except those selling via retail method)',
  },
  {
    code: 5021,
    name: 'Furniture (merchant wholesalers except those selling via retail method)',
  },
  {
    code: 5023,
    name: 'Homefurnishings (merchant wholesalers except those selling via retail method)',
  },
  {
    code: 5031,
    name: 'Lumber, Plywood, Millwork, and Wood Panels (merchant wholesalers)',
  },
  {
    code: 5032,
    name: 'Brick, Stone, and Related Construction Materials  (merchant wholesalers except construction materials sold via retail method)',
  },
  {
    code: 5033,
    name: 'Roofing, Siding, and Insulation Materials (merchant wholesalers except those selling via retail method)',
  },
  {
    code: 5039,
    name: 'Construction Materials, NEC (merchant wholesalers of prefabricated buildings and structural assemblies, wood)',
  },
  {
    code: 5043,
    name: 'Photographic Equipment and Supplies (merchant wholesalers)',
  },
  {
    code: 5044,
    name: 'Office Equipment (merchant wholesalers except those selling office equipment via retail method)',
  },
  {
    code: 5045,
    name: 'Computers and Computer Peripheral Equipment and Software (merchant wholesalers except those selling computers, equipment, and software via retail method)',
  },
  {
    code: 5046,
    name: 'Commercial Equipment, NEC (merchant wholesalers)',
  },
  {
    code: 5047,
    name: 'Medical, Dental and Hospital Equipment and Supplies (merchant wholesalers except those selling medical, dental, and hospital equipment and supplies via retail method)',
  },
  {
    code: 5048,
    name: 'Ophthalmic Goods (merchant wholesalers)',
  },
  {
    code: 5049,
    name: "Professional Equipment and Supplies, NEC (merchant wholesalers except those selling religious and teacher's school supplies via retail method) ",
  },
  {
    code: 5063,
    name: 'Electrical Apparatus and Equipment, Wiring Supplies and Construction Materials (merchant wholesalers except those selling electrical supplies, equipment, and apparatus via retail method)',
  },
  {
    code: 5064,
    name: 'Electrical Appliances, Television and Radio Sets (merchant wholesalers except those selling appliances, TVs, and radios via retail method)',
  },
  {
    code: 5065,
    name: 'Electronic Parts and Equipment, NEC (merchant wholesalers except those selling electronic parts and equipment via retail method)',
  },
  {
    code: 5082,
    name: 'Construction and Mining (Except Petroleum) Machinery and Equipment (merchant wholesalers)',
  },
  {
    code: 5083,
    name: 'Farm and Garden Machinery and Equipment (merchant wholesalers except those selling lawn and garden equipment via retail method)',
  },
  {
    code: 5084,
    name: 'Industrial Machinery and Equipment (merchant wholesalers)',
  },
  {
    code: 5085,
    name: 'Industrial Supplies (merchant wholesalers of fluid power accessories)',
  },
  {
    code: 5087,
    name: 'Service Establishment Equipment and Supplies (merchant wholesalers except those selling beauty and barber shop equipment and supplies via retail method)',
  },
  {
    code: 5088,
    name: 'Transportation Equipment and Supplies, Except Motor Vehicles (merchant wholesalers)',
  },
  {
    code: 5091,
    name: 'Sporting and Recreational Goods and Supplies (merchant wholesalers except those selling sporting and recreational goods via retail method)',
  },
  {
    code: 5092,
    name: 'Toys and Hobby Goods and Supplies (merchant wholesalers except those selling toys and hobby goods and supplies via retail method)',
  },
  {
    code: 5093,
    name: 'Scrap and Waste Materials (merchant wholesalers)',
  },
  {
    code: 5094,
    name: 'Jewelry, Watches, Precious Stones, and Precious Metals (merchant wholesalers except those selling jewelry and related goods via retail method)',
  },
  {
    code: 5099,
    name: 'Durable Goods, NEC (merchant wholesalers except those selling miscellaneous durable goods via retail method)',
  },
  {
    code: 5111,
    name: 'Printing and Writing Paper (merchant wholesalers except those selling printing and writing paper via retail method)',
  },
  {
    code: 5112,
    name: 'Stationery and Office Supplies (merchant wholesalers except those selling stationery and office supplies via retail method)',
  },
  {
    code: 5113,
    name: 'Industrial and Personal Service Paper (merchant wholesalers except those selling industrial and personal service paper via retail method)',
  },
  {
    code: 5122,
    name: 'Drugs, Drug Proprietaries, and Druggists’ Sundries (merchant wholesalers except those selling drugs and sundries via retail method)',
  },
  {
    code: 5131,
    name: 'Piece Goods, Notions, and Other Dry Goods (broadwoven converters)',
  },
  {
    code: 5136,
    name: "Men's and Boys' Clothing and Furnishings (merchant wholesalers of athletic uniforms)",
  },
  {
    code: 5137,
    name: "Women's, Children's and Infants' Clothing and Accessories (merchant wholesalers of athletic uniforms)",
  },
  {
    code: 5139,
    name: 'Footwear (merchant wholesalers except those selling footwear via retail method)',
  },
  {
    code: 5141,
    name: 'Groceries, General Line (merchant wholesalers except those selling general line groceries via retail method)',
  },
  {
    code: 5142,
    name: 'Packaged Frozen Foods (merchant wholesalers except those selling packaged frozen foods via retail method)',
  },
  {
    code: 5143,
    name: 'Dairy Products, Except Dried or Canned (merchant wholesalers except those selling dairy products via retail method)',
  },
  {
    code: 5144,
    name: 'Poultry and Poultry Products (merchant wholesalers except those selling poultry and poultry products via retail method)',
  },
  {
    code: 5145,
    name: 'Confectionery (merchant wholesalers except those selling confectionery via retail method)',
  },
  {
    code: 5146,
    name: 'Fish and Seafoods (merchant wholesalers except those selling fish and seafoods via retail method)',
  },
  {
    code: 5147,
    name: 'Meats and Meat Products (boxed beef)',
  },
  {
    code: 6035,
    name: 'Savings Institutions, Federally Chartered',
  },
  {
    code: 5148,
    name: 'Fresh Fruits and Vegetables (merchant wholesalers except those selling fresh fruits and vegetables via retail method)',
  },
  {
    code: 5149,
    name: 'Groceries and Related Products, NEC (processed bottled water manufacturing) ',
  },
  {
    code: 5172,
    name: 'Petroleum and Petroleum Products Wholesalers, Except Bulk Stations and Terminals (merchant wholesalers)',
  },
  {
    code: 5181,
    name: 'Beer and Ale (merchant wholesalers except those selling beer and ale via retail method)',
  },
  {
    code: 5182,
    name: 'Wine and Distilled Alcoholic Beverages (merchant wholesalers except those selling wine and distilled beverages via retail method)',
  },
  {
    code: 5191,
    name: 'Farm Supplies (merchant wholesalers except those selling lawn and garden supplies via retail method)',
  },
  {
    code: 5192,
    name: 'Books, Periodicals, and Newspapers (merchant wholesalers except those selling publications via retail method)',
  },
  {
    code: 5193,
    name: 'Flowers, Nursery Stock, and Florists’ Supplies (merchant wholesalers except those selling nursery stock via retail method)',
  },
  {
    code: 5194,
    name: 'Tobacco and Tobacco Products (merchant wholesalers except those selling tobacco and tobacco products via retail method)',
  },
  {
    code: 5198,
    name: 'Paints, Varnishes, and Supplies (merchant wholesalers) ',
  },
  {
    code: 5199,
    name: 'Nondurable Goods, NEC (merchant wholesalers of yarns, except industrial)',
  },
  {
    code: 5211,
    name: 'Lumber and Other Building Materials Dealers (home center stores)',
  },
  {
    code: 5231,
    name: 'Paint, Glass, and Wallpaper Stores (except glass)',
  },
  {
    code: 5251,
    name: 'Hardware Stores',
  },
  {
    code: 5261,
    name: 'Retail Nurseries, Lawn and Garden Supply Stores (outdoor power equipment)',
  },
  {
    code: 5271,
    name: 'Mobile Home Dealers',
  },
  {
    code: 5311,
    name: 'Department Stores (except discount department stores and supercenters-general merchandise and groceries)',
  },
  {
    code: 5331,
    name: 'Variety Stores',
  },
  {
    code: 5399,
    name: 'Miscellaneous General Merchandise Stores (warehouse clubs and supermarket/general merchandise combination)',
  },
  {
    code: 5411,
    name: 'Grocery Stores (except convenience stores, freezer plans, and grocery stores with substantial general merchandise)',
  },
  {
    code: 5421,
    name: 'Meat and Fish (Seafood) Markets, Including Freezer Provisioners (meat except freezer provisioners)',
  },
  {
    code: 5431,
    name: 'Fruit and Vegetable Markets (except temporary fruit and vegetable stands)',
  },
  {
    code: 5441,
    name: 'Candy, Nut, and Confectionery Stores (chocolate candy stores, preparing on premises)',
  },
  {
    code: 5451,
    name: 'Dairy Products Stores',
  },
  {
    code: 5461,
    name: 'Retail Bakeries (bread, cake and related products baked and sold on premise)',
  },
  {
    code: 5499,
    name: 'Miscellaneous Food Stores (poultry and poultry products)',
  },
  {
    code: 5531,
    name: 'Auto and Home Supply Stores (auto supply stores)',
  },
  {
    code: 5611,
    name: "Men's and Boys' Clothing and Accessory Stores (clothing stores)",
  },
  {
    code: 5621,
    name: "Women's Clothing Stores (except dress shops and bridal shops)",
  },
  {
    code: 5632,
    name: "Women's Accessory and Specialty Stores (accessories)",
  },
  {
    code: 5641,
    name: "Children's and Infants’ Wear Stores",
  },
  {
    code: 5651,
    name: 'Family Clothing Stores',
  },
  {
    code: 5661,
    name: 'Shoe Stores',
  },
  {
    code: 5699,
    name: 'Miscellaneous Apparel and Accessory Stores (custom tailors)',
  },
  {
    code: 5712,
    name: 'Furniture Stores (custom wood cabinets)',
  },
  {
    code: 5713,
    name: 'Floor Coverings Stores',
  },
  {
    code: 5714,
    name: 'Drapery, Curtain, and Upholstery Stores (custom drapes)',
  },
  {
    code: 5719,
    name: 'Miscellaneous Homefurnishings Stores (manufacturing and selling pottery on site)',
  },
  {
    code: 5722,
    name: 'Household Appliance Stores',
  },
  {
    code: 5731,
    name: 'Radio, Television, and Consumer Electronics Stores (automobile radios)',
  },
  {
    code: 5734,
    name: 'Computer and Computer Software Stores',
  },
  {
    code: 5735,
    name: 'Record and Prerecorded Tape Stores',
  },
  {
    code: 5736,
    name: 'Musical Instruments Stores',
  },
  {
    code: 5812,
    name: 'Eating Places (dinner theaters)',
  },
  {
    code: 5813,
    name: 'Drinking Places (Alcoholic Beverages)',
  },
  {
    code: 5912,
    name: 'Drug Stores and Proprietary Stores',
  },
  {
    code: 5921,
    name: 'Liquor Stores',
  },
  {
    code: 5932,
    name: 'Used Merchandise Stores (except pawn shops)',
  },
  {
    code: 5941,
    name: 'Sporting Goods Stores and Bicycle Shops',
  },
  {
    code: 5942,
    name: 'Book Stores',
  },
  {
    code: 5943,
    name: 'Stationery Stores',
  },
  {
    code: 5944,
    name: 'Jewelry Stores',
  },
  {
    code: 5945,
    name: 'Hobby, Toy, and Game Stores',
  },
  {
    code: 5946,
    name: 'Camera and Photographic Supply Stores',
  },
  {
    code: 5947,
    name: 'Gift, Novelty, and Souvenir Shops',
  },
  {
    code: 5948,
    name: 'Luggage and Leather Goods Stores',
  },
  {
    code: 5949,
    name: 'Sewing, Needlework, and Piece Goods Stores',
  },
  {
    code: 5961,
    name: 'Catalog and Mail-Order Houses (electronic shopping web sites)',
  },
  {
    code: 5962,
    name: 'Automatic Merchandise Machine Operators',
  },
  {
    code: 5963,
    name: 'Direct Selling Establishments (except mobile food services and food wagons)',
  },
  {
    code: 5992,
    name: 'Florists',
  },
  {
    code: 5993,
    name: 'Tobacco Stores and Stands',
  },
  {
    code: 5994,
    name: 'News Dealers and Newsstands ',
  },
  {
    code: 5995,
    name: 'Optical Goods Stores (optical laboratories grinding lenses to prescription)',
  },
  {
    code: 5999,
    name: 'Miscellaneous Retail Stores, NEC (manufacture of orthopedic devices to prescription in a retail environment)',
  },
  {
    code: 6011,
    name: 'Federal Reserve Banks',
  },
  {
    code: 6019,
    name: 'Central Reserve Depository Institutions, NEC',
  },
  {
    code: 6021,
    name: 'National Commercial Banks (banking)',
  },
  {
    code: 6022,
    name: 'State Commercial Banks (commercial banking)',
  },
  {
    code: 6029,
    name: 'Commercial Banks, NEC ',
  },
  {
    code: 6036,
    name: 'Savings Institutions, Not Federally Chartered',
  },
  {
    code: 6061,
    name: 'Credit Unions, Federally Chartered',
  },
  {
    code: 6062,
    name: 'Credit Unions, Not Federally Chartered',
  },
  {
    code: 6081,
    name: 'Branches and Agencies of Foreign Banks (branches)',
  },
  {
    code: 6082,
    name: 'Foreign Trade and International Banking Institutions (international trade financing)',
  },
  {
    code: 6091,
    name: 'Nondeposit Trust Facilities ',
  },
  {
    code: 6099,
    name: 'Functions Related to Depository Banking, NEC (electronic funds transfer networks and clearinghouse associations)',
  },
  {
    code: 6111,
    name: 'Federal and Federally-Sponsored Credit Agencies (trade banks)',
  },
  {
    code: 6141,
    name: 'Personal Credit Institutions (credit card issuing)',
  },
  {
    code: 6153,
    name: 'Short-Term Business Credit Institutions, Except Agricultural (credit card issuing)',
  },
  {
    code: 6159,
    name: 'Miscellaneous Business Credit Institutions (finance leasing combined with sales financing)',
  },
  {
    code: 6162,
    name: 'Mortgage Bankers and Loan Correspondents (mortgage bankers and originators)',
  },
  {
    code: 6163,
    name: 'Loan Brokers',
  },
  {
    code: 6211,
    name: 'Security Brokers, Dealers, and Flotation Companies (security dealers and underwriters)',
  },
  {
    code: 6221,
    name: 'Commodity Contracts Brokers and Dealers (commodity dealers)',
  },
  {
    code: 6231,
    name: 'Security and Commodity Exchanges',
  },
  {
    code: 6282,
    name: 'Investment Advice (portfolio managers)',
  },
  {
    code: 6289,
    name: 'Services Allied With the Exchange of Securities or Commodities, NEC (security custodians)',
  },
  {
    code: 6311,
    name: 'Life Insurance (life insurers-direct)',
  },
  {
    code: 6321,
    name: 'Accident and Health Insurance (disability insurers-direct)',
  },
  {
    code: 6324,
    name: 'Hospital and Medical Service Plans (health and medical insurers-direct)',
  },
  {
    code: 6331,
    name: 'Fire, Marine, and Casualty Insurance (fire, marine, and casualty insurers-direct, except contact lens insurance)',
  },
  {
    code: 6351,
    name: 'Surety Insurance (financial responsibility insurers-direct)',
  },
  {
    code: 6361,
    name: 'Title Insurance (title insurers-direct)',
  },
  {
    code: 6371,
    name: 'Pension, Health, and Welfare Funds (managers)',
  },
  {
    code: 6399,
    name: 'Insurance Carriers, NEC',
  },
  {
    code: 6411,
    name: 'Insurance Agents, Brokers, and Service (insurance agents and brokers)',
  },
  {
    code: 6512,
    name: 'Operators of Nonresidential Buildings (except stadium and arena owners)',
  },
  {
    code: 6513,
    name: 'Operators of Apartment Buildings',
  },
  {
    code: 6514,
    name: 'Operators of Dwellings Other Than Apartment Buildings',
  },
  {
    code: 6515,
    name: 'Operators of Residential Mobile Home Sites',
  },
  {
    code: 6517,
    name: 'Lessors of Railroad Property',
  },
  {
    code: 6519,
    name: 'Lessors of Real Property, NEC',
  },
  {
    code: 6531,
    name: 'Real Estate Agents and Managers (operating housing authorities)',
  },
  {
    code: 6541,
    name: 'Title Abstract Offices',
  },
  {
    code: 6552,
    name: 'Land Subdividers and Developers, Except Cemeteries',
  },
  {
    code: 6553,
    name: 'Cemetery Subdividers and Developers',
  },
  {
    code: 6712,
    name: 'Offices of Bank Holding Companies',
  },
  {
    code: 6719,
    name: 'Offices of Holding Companies, NEC',
  },
  {
    code: 6722,
    name: 'Management Investment Offices, Open-End ',
  },
  {
    code: 6726,
    name: 'Unit Investment Trusts, Face-Amount Certificate Offices, and Closed-End Management Investment Offices',
  },
  {
    code: 6732,
    name: 'Educational, Religious, and Charitable Trusts',
  },
  {
    code: 6733,
    name: 'Trusts, Except Educational, Religious, and Charitable (managers)',
  },
  {
    code: 6792,
    name: 'Oil Royalty Traders (investing on own account)',
  },
  {
    code: 6794,
    name: 'Patent Owners and Lessors',
  },
  {
    code: 6798,
    name: 'Real Estate Investment Trusts',
  },
  {
    code: 6799,
    name: 'Investors, NEC (commodity contract trading companies)',
  },
  {
    code: 7011,
    name: 'Hotels and Motels (hotels, except casino hotels, and motels)',
  },
  {
    code: 7021,
    name: 'Rooming and Boarding Houses',
  },
  {
    code: 7032,
    name: 'Sporting and Recreational Camps',
  },
  {
    code: 7033,
    name: 'Recreational Vehicle Parks and Campsites',
  },
  {
    code: 7041,
    name: 'Organization Hotels and Lodging Houses, on Membership Basis (hotels)',
  },
  {
    code: 7211,
    name: 'Power Laundries, Family and Commercial',
  },
  {
    code: 7212,
    name: 'Garment Pressing, and Agents for Laundries and Drycleaners',
  },
  {
    code: 7213,
    name: 'Linen Supply',
  },
  {
    code: 7215,
    name: 'Coin-Operated Laundry and Drycleaning ',
  },
  {
    code: 7216,
    name: 'Drycleaning Plants, Except Rug Cleaning',
  },
  {
    code: 7217,
    name: 'Carpet and Upholstery Cleaning',
  },
  {
    code: 7218,
    name: 'Industrial Launderers',
  },
  {
    code: 7219,
    name: 'Laundry and Garment Services, NEC (alteration and repair)',
  },
  {
    code: 7221,
    name: 'Photographic Studios, Portrait',
  },
  {
    code: 7231,
    name: 'Beauty Shops (beauty and cosmetology schools)',
  },
  {
    code: 7241,
    name: 'Barber Shops (barber colleges)',
  },
  {
    code: 7251,
    name: 'Shoe Repair Shops and Shoeshine Parlors (shoe repair shops)',
  },
  {
    code: 7261,
    name: 'Funeral Services and Crematories (funeral homes and services)',
  },
  {
    code: 7291,
    name: 'Tax Return Preparation Services',
  },
  {
    code: 7299,
    name: 'Miscellaneous Personal Services, NEC (formal wear and costume rental)',
  },
  {
    code: 7311,
    name: 'Advertising Agencies',
  },
  {
    code: 7312,
    name: 'Outdoor Advertising Services',
  },
  {
    code: 7313,
    name: 'Radio, Television, and Publishers’ Advertising Representatives',
  },
  {
    code: 7319,
    name: 'Advertising, NEC (using general purpose aircraft for aerial advertising and a variety of other services)',
  },
  {
    code: 7322,
    name: 'Adjustment and Collection Services',
  },
  {
    code: 7323,
    name: 'Credit Reporting Services',
  },
  {
    code: 7331,
    name: 'Direct Mail Advertising Services (mailing list compilers)',
  },
  {
    code: 7334,
    name: 'Photocopying and Duplicating Services (quick printing)',
  },
  {
    code: 7335,
    name: 'Commercial Photography (using general purpose aircraft for aerial photography and a variety of other services)',
  },
  {
    code: 7336,
    name: 'Commercial Art and Graphic Design',
  },
  {
    code: 7338,
    name: 'Secretarial and Court Reporting (secretarial services)',
  },
  {
    code: 7352,
    name: 'Medical Equipment Rental and Leasing (home health furniture and equipment rental and leasing)',
  },
  {
    code: 7353,
    name: 'Heavy Construction Equipment Rental and Leasing (rental of construction equipment [except cranes] with operator)',
  },
  {
    code: 7359,
    name: 'Equipment Rental and Leasing, NEC (appliances; TVs, VCRs, and other consumer electronic equipment rental)',
  },
  {
    code: 7361,
    name: 'Employment Agencies (executive placement services)',
  },
  {
    code: 7363,
    name: 'Help Supply Services (temporary help services)',
  },
  {
    code: 7371,
    name: 'Computer Programming Services',
  },
  {
    code: 7372,
    name: 'Prepackaged Software (mass reproduction of software)',
  },
  {
    code: 7373,
    name: 'Computer Integrated Systems Design',
  },
  {
    code: 7374,
    name: 'Computer Processing and Data Preparation and Processing Services',
  },
  {
    code: 7375,
    name: 'Information Retrieval Services (Internet service providers and Internet access providers)',
  },
  {
    code: 7376,
    name: 'Computer Facilities Management Services',
  },
  {
    code: 7377,
    name: 'Computer Rental and Leasing',
  },
  {
    code: 7378,
    name: 'Computer Maintenance and Repair (sales locations providing supporting repair services as major source of receipts)',
  },
  {
    code: 7379,
    name: 'Computer Related Services, NEC (disk conversion services)',
  },
  {
    code: 7383,
    name: 'News Syndicates (except independent news correspondents)',
  },
  {
    code: 7384,
    name: 'Photofinishing Laboratories (except one-hour)',
  },
  {
    code: 7389,
    name: 'Business Services, NEC (tobacco sheeting service)',
  },
  {
    code: 7513,
    name: 'Truck Rental and Leasing Without Drivers',
  },
  {
    code: 7514,
    name: 'Passenger Car Rental',
  },
  {
    code: 7515,
    name: 'Passenger Car Leasing',
  },
  {
    code: 7519,
    name: 'Utility Trailers and Recreational Vehicle Rental',
  },
  {
    code: 7521,
    name: 'Automobile Parking',
  },
  {
    code: 7532,
    name: 'Top, Body, and Upholstery Repair Shops and Paint Shops',
  },
  {
    code: 7533,
    name: 'Automotive Exhaust System Repair Shops',
  },
  {
    code: 7534,
    name: 'Tire Retreading and Repair Shops (rebuilding tires and retreaded tire manufacturing)',
  },
  {
    code: 7536,
    name: 'Automotive Glass Replacement Shops',
  },
  {
    code: 7537,
    name: 'Automotive Transmission Repair Shops',
  },
  {
    code: 7538,
    name: 'General Automotive Repair Shops',
  },
  {
    code: 7539,
    name: 'Automotive Repair Shops, NEC (except automotive air-conditioning repair)',
  },
  {
    code: 7542,
    name: 'Carwashes',
  },
  {
    code: 7549,
    name: 'Automotive Services, Except Repair and Carwashes (towing)',
  },
  {
    code: 7622,
    name: 'Radio and Television Repair Shops (household antenna installation and household-type satellite dish installation)',
  },
  {
    code: 7623,
    name: 'Refrigeration and Air-Conditioning Services and Repair Shops (new retail sales combined with repair-repair services as major source of receipts)',
  },
  {
    code: 7629,
    name: 'Electrical and Electronic Repair Shops, NEC (new retail sales combined with repair-repair services as major source of receipts)',
  },
  {
    code: 7631,
    name: 'Watch, Clock, and Jewelry Repair (new retail sales combined with repair-repair services as major source of receipts)',
  },
  {
    code: 7641,
    name: 'Reupholstery and Furniture Repair',
  },
  {
    code: 7692,
    name: 'Welding Repair',
  },
  {
    code: 7694,
    name: 'Armature Rewinding Shops (remanufacturing)',
  },
  {
    code: 7699,
    name: 'Repair Shops and Related Services, NEC (farriers)',
  },
  {
    code: 7812,
    name: 'Motion Picture and Video Tape Production',
  },
  {
    code: 7819,
    name: 'Services Allied to Motion Picture Production (reproduction of video)',
  },
  {
    code: 7822,
    name: 'Motion Picture and Video Tape Distribution (prerecorded video tape and cassette wholesalers)',
  },
  {
    code: 7829,
    name: 'Services Allied to Motion Picture Distribution (commercial distribution film libraries)',
  },
  {
    code: 7832,
    name: 'Motion Picture Theaters, Except Drive-In',
  },
  {
    code: 7833,
    name: 'Drive-In Motion Picture Theaters',
  },
  {
    code: 7841,
    name: 'Video Tape Rental',
  },
  {
    code: 7911,
    name: 'Dance Studios, Schools, and Halls (dance instructors, and professional and other dance schools)',
  },
  {
    code: 7922,
    name: 'Theatrical Producers (Except Motion Picture) and Miscellaneous Theatrical Services (producers of radio programs)',
  },
  {
    code: 7929,
    name: 'Bands, Orchestras, Actors, and Other Entertainers Entertainment Groups (musical groups, musical artists, and orchestras)',
  },
  {
    code: 7933,
    name: 'Bowling Centers',
  },
  {
    code: 7991,
    name: 'Physical Fitness Facilities',
  },
  {
    code: 7992,
    name: 'Public Golf Courses',
  },
  {
    code: 7993,
    name: 'Coin-Operated Amusement Devices (amusement arcades)',
  },
  {
    code: 7996,
    name: 'Amusement Parks',
  },
  {
    code: 7997,
    name: 'Membership Sports and Recreation Clubs (flying clubs primarily providing a variety of flying services to the public using general purpose aircraft)',
  },
  {
    code: 7999,
    name: 'Amusement and Recreation Services, NEC (scenic transport operations, land)',
  },
  {
    code: 8011,
    name: 'Offices and Clinics of Doctors of Medicine (except mental health specialists, HMO medical centers, and ambulatory surgical and emergency centers)',
  },
  {
    code: 8021,
    name: 'Offices and Clinics of Dentists',
  },
  {
    code: 8031,
    name: 'Offices and Clinics of Doctors of Osteopathy (except mental health specialists) ',
  },
  {
    code: 8041,
    name: 'Offices and Clinics of Chiropractors',
  },
  {
    code: 8042,
    name: 'Offices and Clinics of Optometrists',
  },
  {
    code: 8043,
    name: 'Offices and Clinics of Podiatrists',
  },
  {
    code: 8049,
    name: 'Offices and Clinics of Health Practitioners, NEC (mental health practitioners except physicians)',
  },
  {
    code: 8051,
    name: 'Skilled Nursing Care Facilities (except continuing care retirement communities and mental retardation hospitals)',
  },
  {
    code: 8052,
    name: 'Intermediate Care Facilities (except continuing care retirement communities and mental retardation facilities)',
  },
  {
    code: 8059,
    name: 'Nursing and Personal Care Facilities, NEC (except continuing care retirement communities, psychiatric convalescent homes with health care, and homes for the mentally retarded with health care)',
  },
  {
    code: 8062,
    name: 'General Medical and Surgical Hospitals',
  },
  {
    code: 8063,
    name: 'Psychiatric Hospitals',
  },
  {
    code: 8069,
    name: 'Specialty Hospitals, Except Psychiatric (children’s hospitals)',
  },
  {
    code: 8071,
    name: 'Medical Laboratories (except diagnostic imaging centers)',
  },
  {
    code: 8072,
    name: 'Dental Laboratories',
  },
  {
    code: 8082,
    name: 'Home Health Care Services',
  },
  {
    code: 8092,
    name: 'Kidney Dialysis Centers',
  },
  {
    code: 8093,
    name: 'Specialty Outpatient Facilities, NEC (respiratory therapy clinics and offices)',
  },
  {
    code: 8099,
    name: 'Health and Allied Services, NEC (medical artists)',
  },
  {
    code: 8111,
    name: 'Legal Services',
  },
  {
    code: 8211,
    name: 'Elementary and Secondary Schools',
  },
  {
    code: 8221,
    name: 'Colleges, Universities, and Professional Schools',
  },
  {
    code: 8222,
    name: 'Junior Colleges and Technical Institutes',
  },
  {
    code: 8231,
    name: 'Libraries',
  },
  {
    code: 8243,
    name: 'Data Processing Schools (except computer repair training)',
  },
  {
    code: 8244,
    name: 'Business and Secretarial Schools',
  },
  {
    code: 8249,
    name: 'Vocational Schools, NEC (aviation schools, excluding flying instruction)',
  },
  {
    code: 8299,
    name: 'Schools and Educational Services, NEC (professional and management development training)',
  },
  {
    code: 8322,
    name: 'Individual and Family Social Services (child and youth services)',
  },
  {
    code: 8331,
    name: 'Job Training and Vocational Rehabilitation Services',
  },
  {
    code: 8351,
    name: 'Child Day Care Services',
  },
  {
    code: 8361,
    name: 'Residential Care (homes for the mentally handicapped with incidental health care)',
  },
  {
    code: 8399,
    name: 'Social Services, NEC (voluntary health organizations)',
  },
  {
    code: 8412,
    name: 'Museums and Art Galleries (except historic and heritage sites)',
  },
  {
    code: 8422,
    name: 'Arboreta and Botanical or Zoological Gardens (except nature parks and reserves)',
  },
  {
    code: 8711,
    name: 'Engineering Services',
  },
  {
    code: 8712,
    name: 'Architectural Services',
  },
  {
    code: 8713,
    name: 'Surveying Services (geophysical surveying )',
  },
  {
    code: 8721,
    name: 'Accounting, Auditing, and Bookkeeping Services (auditing accountants)',
  },
  {
    code: 8731,
    name: 'Commercial Physical and Biological Research',
  },
  {
    code: 8732,
    name: 'Commercial Economic, Sociological, and Educational Research (social sciences and humanities)',
  },
  {
    code: 8733,
    name: 'Noncommercial Research Organizations (physical, engineering, and life sciences)',
  },
  {
    code: 8734,
    name: 'Testing Laboratories (except veterinary testing laboratories)',
  },
  {
    code: 8741,
    name: 'Management Services (single-family housing construction management)',
  },
  {
    code: 8742,
    name: 'Management Consulting Services (administrative management and general management consulting)',
  },
  {
    code: 8743,
    name: 'Public Relations Services',
  },
  {
    code: 8744,
    name: 'Facilities Support Management Services',
  },
  {
    code: 8748,
    name: 'Business Consulting Services, NEC (urban planners and industrial development organizations)',
  },
  {
    code: 8811,
    name: 'Private Households',
  },
  {
    code: 8999,
    name: 'Services, NEC (record production)',
  },
  {
    code: 9111,
    name: 'Executive Offices',
  },
  {
    code: 9121,
    name: 'Legislative Bodies',
  },
  {
    code: 9131,
    name: 'Executive and Legislative Office Combined ',
  },
  {
    code: 9199,
    name: 'General Government, NEC',
  },
  {
    code: 9211,
    name: 'Courts',
  },
  {
    code: 9222,
    name: 'Legal Counsel and Prosecution',
  },
  {
    code: 9311,
    name: 'Public Finance, Taxation, and Monetary Policy',
  },
  {
    code: 9411,
    name: 'Administration of Educational Programs',
  },
  {
    code: 9431,
    name: 'Administration of Public Health Programs',
  },
  {
    code: 9441,
    name: 'Administration of Social, Human Resource and Income Maintenance Programs',
  },
  {
    code: 9451,
    name: 'Administration of Veterans’ Affairs, Except Health and Insurance',
  },
  {
    code: 9531,
    name: 'Administration of Housing Programs',
  },
  {
    code: 9532,
    name: 'Administration of Urban Planning and Community and Rural Development',
  },
  {
    code: 9611,
    name: 'Administration of General Economic Programs',
  },
  {
    code: 9621,
    name: 'Regulation and Administration of Transportation Programs (government air traffic control)',
  },
  {
    code: 9631,
    name: 'Regulation and Administration of Communications, Electric, Gas, and Other Utilities',
  },
  {
    code: 9641,
    name: 'Regulation of Agricultural Marketing and Commodities',
  },
  {
    code: 9651,
    name: 'Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors',
  },
  {
    code: 0,
    name: 'Not Applicable',
  },
  {
    code: 111998,
    name: 'All Other Miscellaneous Crop Farming',
  },
  {
    code: 115210,
    name: 'Support Activities for Animal Production',
  },
  {
    code: 221111,
    name: 'Hydroelectric Power Generation',
  },
  {
    code: 221310,
    name: 'Water Supply and Irrigation Systems',
  },
  {
    code: 236115,
    name: 'New Single-Family Housing Construction (except Operative Builders)',
  },
  {
    code: 237210,
    name: 'Land Subdivision',
  },
  {
    code: 237310,
    name: 'Highway, Street, and Bridge Construction',
  },
  {
    code: 238290,
    name: 'Other Building Equipment Contractors',
  },
  {
    code: 238910,
    name: 'Site Preparation Contractors',
  },
  {
    code: 311111,
    name: 'Dog and Cat Food Manufacturing',
  },
  {
    code: 311119,
    name: 'Other Animal Food Manufacturing',
  },
  {
    code: 311211,
    name: 'Flour Milling',
  },
  {
    code: 311212,
    name: 'Rice Milling',
  },
  {
    code: 311213,
    name: 'Malt Manufacturing',
  },
  {
    code: 311221,
    name: 'Wet Corn Milling',
  },
  {
    code: 311222,
    name: 'Soybean Processing',
  },
  {
    code: 311223,
    name: 'Other Oilseed Processing',
  },
  {
    code: 311230,
    name: 'Breakfast Cereal Manufacturing',
  },
  {
    code: 311311,
    name: 'Sugarcane Mills',
  },
  {
    code: 311312,
    name: 'Cane Sugar Refining',
  },
  {
    code: 311313,
    name: 'Beet Sugar Manufacturing',
  },
  {
    code: 311320,
    name: 'Chocolate and Confectionery Manufacturing from Cacao Beans',
  },
  {
    code: 311330,
    name: 'Confectionery Manufacturing from Purchased Chocolate ',
  },
  {
    code: 311340,
    name: 'Nonchocolate Confectionery Manufacturing',
  },
  {
    code: 311612,
    name: 'Meat Processed from Carcasses ',
  },
  {
    code: 311613,
    name: 'Rendering and Meat Byproduct Processing',
  },
  {
    code: 311711,
    name: 'Seafood Canning',
  },
  {
    code: 311712,
    name: 'Fresh and Frozen Seafood Processing',
  },
  {
    code: 311811,
    name: 'Retail Bakeries',
  },
  {
    code: 311812,
    name: 'Commercial Bakeries',
  },
  {
    code: 311813,
    name: 'Frozen Cakes, Pies, and Other Pastries Manufacturing',
  },
  {
    code: 311822,
    name: 'Flour Mixes and Dough Manufacturing from Purchased Flour',
  },
  {
    code: 311823,
    name: 'Dry Pasta Manufacturing ',
  },
  {
    code: 311911,
    name: 'Roasted Nuts and Peanut Butter Manufacturing',
  },
  {
    code: 311919,
    name: 'Other Snack Food Manufacturing',
  },
  {
    code: 311920,
    name: 'Coffee and Tea Manufacturing',
  },
  {
    code: 311942,
    name: 'Spice and Extract Manufacturing',
  },
  {
    code: 312111,
    name: 'Soft Drink Manufacturing',
  },
  {
    code: 312112,
    name: 'Bottled Water Manufacturing',
  },
  {
    code: 312113,
    name: 'Ice Manufacturing',
  },
  {
    code: 312130,
    name: 'Wineries',
  },
  {
    code: 312210,
    name: 'Tobacco Stemming and Redrying',
  },
  {
    code: 312221,
    name: 'Cigarette Manufacturing',
  },
  {
    code: 312229,
    name: 'Other Tobacco Product Manufacturing',
  },
  {
    code: 313111,
    name: 'Yarn Spinning Mills',
  },
  {
    code: 313112,
    name: 'Yarn Texturing, Throwing, and Twisting Mills',
  },
  {
    code: 313113,
    name: 'Thread Mills',
  },
  {
    code: 313210,
    name: 'Broadwoven Fabric Mills',
  },
  {
    code: 313221,
    name: 'Narrow Fabric Mills',
  },
  {
    code: 313222,
    name: 'Schiffli Machine Embroidery',
  },
  {
    code: 313230,
    name: 'Nonwoven Fabric Mills',
  },
  {
    code: 313241,
    name: 'Weft Knit Fabric Mills',
  },
  {
    code: 313249,
    name: 'Other Knit Fabric and Lace Mills',
  },
  {
    code: 313311,
    name: 'Broadwoven Fabric Finishing Mills',
  },
  {
    code: 313312,
    name: 'Textile and Fabric Finishing (except Broadwoven Fabric) Mills',
  },
  {
    code: 313320,
    name: 'Fabric Coating Mills',
  },
  {
    code: 314110,
    name: 'Carpet and Rug Mills',
  },
  {
    code: 314121,
    name: 'Curtain and Drapery Mills',
  },
  {
    code: 314129,
    name: 'Other Household Textile Product Mills',
  },
  {
    code: 314911,
    name: 'Textile Bag Mills',
  },
  {
    code: 314912,
    name: 'Canvas and Related Product Mills',
  },
  {
    code: 314992,
    name: 'Tire Cord and Tire Fabric Mills',
  },
  {
    code: 314999,
    name: 'All Other Miscellaneous Textile Product Mills',
  },
  {
    code: 315211,
    name: 'Men’s and Boys’ Cut and Sew Apparel Contractors',
  },
  {
    code: 315212,
    name: 'Women’s, Girls’, and Infants’ Cut and Sew Apparel Contractors',
  },
  {
    code: 315222,
    name: 'Men’s and Boys’ Cut and Sew Suit, Coat and Overcoat Manufacturing ',
  },
  {
    code: 316212,
    name: 'House Slipper Manufacturing',
  },
  {
    code: 316213,
    name: 'Men’s Footwear (except Athletic) Manufacturing',
  },
  {
    code: 316214,
    name: 'Women’s Footwear (except Athletic) Manufacturing ',
  },
  {
    code: 316219,
    name: 'Other Footwear Manufacturing',
  },
  {
    code: 316991,
    name: 'Luggage Manufacturing',
  },
  {
    code: 316992,
    name: "Women's Handbag and Purse Manufacturing",
  },
  {
    code: 316993,
    name: 'Personal Leather Good (except Women’s Handbag and Purse) Manufacturing',
  },
  {
    code: 316999,
    name: 'All Other Leather Good Manufacturing',
  },
  {
    code: 322110,
    name: 'Pulp Mills',
  },
  {
    code: 322121,
    name: 'Paper (except Newsprint) Mills',
  },
  {
    code: 322130,
    name: 'Paperboard Mills',
  },
  {
    code: 322211,
    name: 'Corrugated and Solid Fiber Box Manufacturing',
  },
  {
    code: 322212,
    name: 'Folding Paperboard Box Manufacturing',
  },
  {
    code: 322213,
    name: 'Setup Paperboard Box Manufacturing',
  },
  {
    code: 322214,
    name: 'Fiber Can, Tube, Drum, and Similar Products Manufacturing',
  },
  {
    code: 322215,
    name: 'Nonfolding Sanitary Food Container Manufacturing',
  },
  {
    code: 322221,
    name: 'Coated and Laminated Packaging Paper and Plastics Film Manufacturing',
  },
  {
    code: 322222,
    name: 'Coated and Laminated Paper Manufacturing',
  },
  {
    code: 322223,
    name: 'Plastics, Foil, and Coated Paper Bag Manufacturing',
  },
  {
    code: 322224,
    name: 'Uncoated Paper and Multiwall Bag Manufacturing',
  },
  {
    code: 322226,
    name: 'Surface-Coated Paperboard Manufacturing',
  },
  {
    code: 322232,
    name: 'Envelope Manufacturing',
  },
  {
    code: 322233,
    name: 'Stationery, Tablet, and Related Product Manufacturing',
  },
  {
    code: 322291,
    name: 'Sanitary Paper Product Manufacturing',
  },
  {
    code: 323110,
    name: 'Commercial Lithographic Printing',
  },
  {
    code: 323111,
    name: 'Commercial Gravure Printing',
  },
  {
    code: 323112,
    name: 'Commercial Flexographic Printing',
  },
  {
    code: 323113,
    name: 'Commercial Screen Printing',
  },
  {
    code: 323114,
    name: 'Quick Printing',
  },
  {
    code: 323116,
    name: 'Manifold Business Form Printing',
  },
  {
    code: 323117,
    name: 'Book Printing',
  },
  {
    code: 323121,
    name: 'Tradebinding and Related Work',
  },
  {
    code: 323122,
    name: 'Prepress Services',
  },
  {
    code: 325191,
    name: 'Gum and Wood Chemical Manufacturing',
  },
  {
    code: 325222,
    name: 'Noncellulosic Organic Fiber Manufacturing',
  },
  {
    code: 325411,
    name: 'Medicinal and Botanical Manufacturing',
  },
  {
    code: 325412,
    name: 'Pharmaceutical Preparation Manufacturing',
  },
  {
    code: 325414,
    name: 'Biological Product (except Diagnostic) Manufacturing',
  },
  {
    code: 325510,
    name: 'Paint and Coating Manufacturing',
  },
  {
    code: 325611,
    name: 'Soap and Other Detergent Manufacturing',
  },
  {
    code: 325612,
    name: 'Polish and Other Sanitation Good Manufacturing',
  },
  {
    code: 325613,
    name: 'Surface Active Agent Manufacturing',
  },
  {
    code: 325992,
    name: 'Photographic Film, Paper, Plate, and Chemical Manufacturing',
  },
  {
    code: 325998,
    name: 'All Other Miscellaneous Chemical Product and Preparation Manufacturing',
  },
  {
    code: 326192,
    name: 'Resilient Floor Covering Manufacturing',
  },
  {
    code: 326212,
    name: 'Tire Retreading',
  },
  {
    code: 327112,
    name: 'Vitreous China, Fine Earthenware, and Other Pottery Product Manufacturing',
  },
  {
    code: 332211,
    name: 'Cutlery and Flatware (except Precious) Manufacturing',
  },
  {
    code: 332212,
    name: 'Hand and Edge Tool Manufacturing',
  },
  {
    code: 332213,
    name: 'Saw Blade and Handsaw Manufacturing',
  },
  {
    code: 332431,
    name: 'Metal Can Manufacturing',
  },
  {
    code: 332439,
    name: 'Other Metal Container Manufacturing',
  },
  {
    code: 332710,
    name: 'Machine Shops',
  },
  {
    code: 332912,
    name: 'Fluid Power Valve and Hose Fitting Manufacturing',
  },
  {
    code: 332913,
    name: 'Plumbing Fixture Fitting and Trim Manufacturing',
  },
  {
    code: 332994,
    name: 'Small Arms Manufacturing',
  },
  {
    code: 332998,
    name: 'Enameled Iron and Metal Sanitary Ware Manufacturing',
  },
  {
    code: 333298,
    name: 'All Other Industrial Machinery Manufacturing',
  },
  {
    code: 333311,
    name: 'Automatic Vending Machine Manufacturing',
  },
  {
    code: 333312,
    name: 'Commercial Laundry, Drycleaning, and Pressing Machine Manufacturing',
  },
  {
    code: 333313,
    name: 'Office Machinery Manufacturing',
  },
  {
    code: 333314,
    name: 'Optical Instrument and Lens Manufacturing',
  },
  {
    code: 333319,
    name: 'Other Commercial and Service Industry Machinery Manufacturing',
  },
  {
    code: 333414,
    name: 'Heating Equipment (except Warm Air Furnaces) Manufacturing',
  },
  {
    code: 333415,
    name: 'Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing',
  },
  {
    code: 333911,
    name: 'Pump and Pumping Equipment Manufacturing',
  },
  {
    code: 333913,
    name: 'Measuring and Dispensing Pump Manufacturing',
  },
  {
    code: 333924,
    name: 'Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing',
  },
  {
    code: 333995,
    name: 'Fluid Power Cylinder and Actuator Manufacturing',
  },
  {
    code: 333996,
    name: 'Fluid Power Pump and Motor Manufacturing',
  },
  {
    code: 333997,
    name: 'Scale and Balance (except Laboratory) Manufacturing',
  },
  {
    code: 334111,
    name: 'Electronic Computer Manufacturing',
  },
  {
    code: 334112,
    name: 'Computer Storage Device Manufacturing',
  },
  {
    code: 334113,
    name: 'Computer Terminal Manufacturing',
  },
  {
    code: 334119,
    name: 'Other Computer Peripheral Equipment Manufacturing',
  },
  {
    code: 334210,
    name: 'Telephone Apparatus Manufacturing',
  },
  {
    code: 334220,
    name: 'Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing',
  },
  {
    code: 334290,
    name: 'Other Communications Equipment Manufacturing',
  },
  {
    code: 334310,
    name: 'Audio and Video Equipment Manufacturing',
  },
  {
    code: 334411,
    name: 'Electron Tube Manufacturing',
  },
  {
    code: 334412,
    name: 'Bare Printed Circuit Board Manufacturing',
  },
  {
    code: 334413,
    name: 'Semiconductor and Related Device Manufacturing',
  },
  {
    code: 334414,
    name: 'Electronic Capacitor Manufacturing',
  },
  {
    code: 334415,
    name: 'Electronic Resistor Manufacturing',
  },
  {
    code: 334416,
    name: 'Electronic Coil, Transformer, and Other Inductor Manufacturing',
  },
  {
    code: 334417,
    name: 'Electronic Connector Manufacturing',
  },
  {
    code: 334510,
    name: 'Electromedical and Electrotherapeutic Apparatus Manufacturing',
  },
  {
    code: 334511,
    name: 'Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing',
  },
  {
    code: 334512,
    name: 'Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use',
  },
  {
    code: 334513,
    name: 'Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables',
  },
  {
    code: 334514,
    name: 'Totalizing Fluid Meter and Counting Device Manufacturing',
  },
  {
    code: 334516,
    name: 'Analytical Laboratory Instrument Manufacturing',
  },
  {
    code: 334517,
    name: 'Irradiation Apparatus Manufacturing',
  },
  {
    code: 334518,
    name: 'Watch, Clock, and Part Manufacturing',
  },
  {
    code: 334611,
    name: 'Software Reproducing',
  },
  {
    code: 334612,
    name: 'Prerecorded Compact Disc (except Software), Tape, and Record Reproducing',
  },
  {
    code: 334613,
    name: 'Magnetic and Optical Recording Media Manufacturing',
  },
  {
    code: 335110,
    name: 'Electric Lamp Bulb and Part Manufacturing',
  },
  {
    code: 335121,
    name: 'Residential Electric Lighting Fixture Manufacturing ',
  },
  {
    code: 335122,
    name: 'Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing',
  },
  {
    code: 335129,
    name: 'Other Lighting Equipment Manufacturing',
  },
  {
    code: 335212,
    name: 'Household Vacuum Cleaner Manufacturing',
  },
  {
    code: 335221,
    name: 'Household Cooking Appliance Manufacturing',
  },
  {
    code: 335222,
    name: 'Household Refrigerator and Home Freezer Manufacturing',
  },
  {
    code: 335224,
    name: 'Household Laundry Equipment Manufacturing',
  },
  {
    code: 335311,
    name: 'Power, Distribution, and Specialty Transformer Manufacturing',
  },
  {
    code: 335312,
    name: 'Motor and Generator Manufacturing',
  },
  {
    code: 335313,
    name: 'Switchgear and Switchboard Apparatus Manufacturing',
  },
  {
    code: 335314,
    name: 'Relay and Industrial Control Manufacturing',
  },
  {
    code: 335911,
    name: 'Storage Battery Manufacturing',
  },
  {
    code: 335912,
    name: 'Primary Battery Manufacturing',
  },
  {
    code: 335931,
    name: 'Current-Carrying Wiring Device Manufacturing',
  },
  {
    code: 335991,
    name: 'Carbon and Graphite Product Manufacturing',
  },
  {
    code: 335999,
    name: 'All Other Miscellaneous Electrical Equipment and Component Manufacturing',
  },
  {
    code: 336111,
    name: 'Automobile Manufacturing',
  },
  {
    code: 336211,
    name: 'Motor Vehicle Body Manufacturing',
  },
  {
    code: 336212,
    name: 'Truck Trailer Manufacturing',
  },
  {
    code: 336213,
    name: 'Motor Home Manufacturing',
  },
  {
    code: 336214,
    name: 'Travel Trailer and Camper Manufacturing',
  },
  {
    code: 336311,
    name: 'Carburetor, Piston, Piston Ring, and Valve Manufacturing',
  },
  {
    code: 336321,
    name: 'Vehicular Lighting Equipment Manufacturing',
  },
  {
    code: 336322,
    name: 'Other Motor Vehicle Electrical and Electronic Equipment Manufacturing',
  },
  {
    code: 336360,
    name: 'Motor Vehicle Seating and Interior Trim Manufacturing',
  },
  {
    code: 336411,
    name: 'Aircraft Manufacturing',
  },
  {
    code: 336412,
    name: 'Aircraft Engine and Engine Parts Manufacturing',
  },
  {
    code: 336611,
    name: 'Ship Building and Repairing',
  },
  {
    code: 336612,
    name: 'Boat Building ',
  },
  {
    code: 336991,
    name: 'Motorcycle, Bicycle, and Parts Manufacturing',
  },
  {
    code: 336992,
    name: 'Military Armored Vehicle, Tank, and Tank Component Manufacturing',
  },
  {
    code: 337110,
    name: 'Wood Kitchen Cabinet and Countertop Manufacturing',
  },
  {
    code: 337121,
    name: 'Upholstered Household Furniture Manufacturing',
  },
  {
    code: 337122,
    name: 'Nonupholstered Wood Household Furniture Manufacturing',
  },
  {
    code: 337125,
    name: 'Household Furniture (except Wood and Metal) Manufacturing',
  },
  {
    code: 337127,
    name: 'Institutional Furniture Manufacturing',
  },
  {
    code: 337129,
    name: 'Wood Television, Radio, and Sewing Machine Cabinet Manufacturing',
  },
  {
    code: 337211,
    name: 'Wood Office Furniture Manufacturing ',
  },
  {
    code: 337214,
    name: 'Office Furniture (except Wood) Manufacturing',
  },
  {
    code: 337920,
    name: 'Blind and Shade Manufacturing',
  },
  {
    code: 339111,
    name: 'Laboratory Apparatus and Furniture Manufacturing',
  },
  {
    code: 339113,
    name: 'Surgical Appliance and Supplies Manufacturing',
  },
  {
    code: 339114,
    name: 'Dental Equipment and Supplies Manufacturing',
  },
  {
    code: 339115,
    name: 'Ophthalmic Goods Manufacturing',
  },
  {
    code: 339116,
    name: 'Dental Laboratories',
  },
  {
    code: 339911,
    name: 'Jewelry (except Costume) Manufacturing',
  },
  {
    code: 339914,
    name: 'Costume Jewelry and Novelty Manufacturing',
  },
  {
    code: 339920,
    name: 'Sporting and Athletic Goods Manufacturing',
  },
  {
    code: 339931,
    name: 'Doll and Stuffed Toy Manufacturing',
  },
  {
    code: 339941,
    name: 'Pen and Mechanical Pencil Manufacturing',
  },
  {
    code: 339943,
    name: 'Marking Device Manufacturing',
  },
  {
    code: 339944,
    name: 'Carbon Paper and Inked Ribbon Manufacturing',
  },
  {
    code: 339992,
    name: 'Musical Instrument Manufacturing',
  },
  {
    code: 339993,
    name: 'Fastener, Button, Needle, and Pin Manufacturing',
  },
  {
    code: 339994,
    name: 'Broom, Brush, and Mop Manufacturing',
  },
  {
    code: 339995,
    name: 'Burial Casket Manufacturing',
  },
  {
    code: 423110,
    name: 'Automobile and Other Motor Vehicle Merchant Wholesalers',
  },
  {
    code: 423120,
    name: 'Motor Vehicle Supplies and New Parts Merchant Wholesalers',
  },
  {
    code: 423130,
    name: 'Tire and Tube Merchant Wholesalers',
  },
  {
    code: 423140,
    name: 'Motor Vehicle Parts (Used) Merchant Wholesalers',
  },
  {
    code: 423210,
    name: 'Furniture Merchant Wholesalers',
  },
  {
    code: 423220,
    name: 'Home Furnishing Merchant Wholesalers',
  },
  {
    code: 423310,
    name: 'Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers',
  },
  {
    code: 423320,
    name: 'Brick, Stone, and Related Construction Material Merchant Wholesalers',
  },
  {
    code: 423330,
    name: 'Roofing, Siding, and Insulation Material Merchant Wholesalers',
  },
  {
    code: 423410,
    name: 'Photographic Equipment and Supplies Merchant Wholesalers',
  },
  {
    code: 423420,
    name: 'Office Equipment Merchant Wholesalers',
  },
  {
    code: 423430,
    name: 'Computer and Computer Peripheral Equipment and Software Merchant Wholesalers',
  },
  {
    code: 423440,
    name: 'Other Commercial Equipment Merchant Wholesalers',
  },
  {
    code: 423450,
    name: 'Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers',
  },
  {
    code: 423460,
    name: 'Ophthalmic Goods Merchant Wholesalers',
  },
  {
    code: 423490,
    name: 'Other Professional Equipment and Supplies Merchant Wholesalers',
  },
  {
    code: 423610,
    name: 'Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers',
  },
  {
    code: 423620,
    name: 'Electrical and Electronic Appliance, Television, and Radio Set Merchant Wholesalers',
  },
  {
    code: 423690,
    name: 'Other Electronic Parts and Equipment Merchant Wholesalers',
  },
  {
    code: 423810,
    name: 'Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers',
  },
  {
    code: 423820,
    name: 'Farm and Garden Machinery and Equipment Merchant Wholesalers',
  },
  {
    code: 423830,
    name: 'Industrial Machinery and Equipment Merchant Wholesalers',
  },
  {
    code: 423850,
    name: 'Service Establishment Equipment and Supplies Merchant Wholesalers',
  },
  {
    code: 423860,
    name: 'Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers',
  },
  {
    code: 423910,
    name: 'Sporting and Recreational Goods and Supplies Merchant Wholesalers',
  },
  {
    code: 423920,
    name: 'Toy and Hobby Goods and Supplies Merchant Wholesalers',
  },
  {
    code: 423930,
    name: 'Recyclable Material Merchant Wholesalers',
  },
  {
    code: 423940,
    name: 'Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers',
  },
  {
    code: 423990,
    name: 'Other Miscellaneous Durable Goods Merchant Wholesalers',
  },
  {
    code: 424110,
    name: 'Printing and Writing Paper Merchant Wholesalers',
  },
  {
    code: 424120,
    name: 'Stationery and Office Supplies Merchant Wholesalers',
  },
  {
    code: 424130,
    name: 'Industrial and Personal Service Paper Merchant Wholesalers',
  },
  {
    code: 424210,
    name: 'Drugs and Druggists’ Sundries Merchant Wholesalers',
  },
  {
    code: 424310,
    name: 'Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers',
  },
  {
    code: 424340,
    name: 'Footwear Merchant Wholesalers',
  },
  {
    code: 424410,
    name: 'General Line Grocery Merchant Wholesalers',
  },
  {
    code: 424420,
    name: 'Packaged Frozen Food Merchant Wholesalers',
  },
  {
    code: 424430,
    name: 'Dairy Product (except Dried or Canned) Merchant Wholesalers',
  },
  {
    code: 424440,
    name: 'Poultry and Poultry Product Merchant Wholesalers',
  },
  {
    code: 424450,
    name: 'Confectionery Merchant Wholesalers',
  },
  {
    code: 424460,
    name: 'Fish and Seafood Merchant Wholesalers',
  },
  {
    code: 424480,
    name: 'Fresh Fruit and Vegetable Merchant Wholesalers',
  },
  {
    code: 424720,
    name: 'Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)',
  },
  {
    code: 424810,
    name: 'Beer and Ale Merchant Wholesalers',
  },
  {
    code: 424820,
    name: 'Wine and Distilled Alcoholic Beverage Merchant Wholesalers',
  },
  {
    code: 424910,
    name: 'Farm Supplies Merchant Wholesalers',
  },
  {
    code: 424920,
    name: 'Book, Periodical, and Newspaper Merchant Wholesalers',
  },
  {
    code: 424930,
    name: 'Flower, Nursery Stock, and Florists’ Supplies Merchant Wholesalers',
  },
  {
    code: 424940,
    name: 'Tobacco and Tobacco Product Merchant Wholesalers',
  },
  {
    code: 424950,
    name: 'Paint, Varnish, and Supplies Merchant Wholesalers',
  },
  {
    code: 441310,
    name: 'Automotive Parts and Accessories Stores',
  },
  {
    code: 442210,
    name: 'Floor Covering Stores',
  },
  {
    code: 443111,
    name: 'Household Appliance Stores',
  },
  {
    code: 443120,
    name: 'Computer and Software Stores',
  },
  {
    code: 443130,
    name: 'Camera and Photographic Supplies Stores',
  },
  {
    code: 444110,
    name: 'Home Centers',
  },
  {
    code: 444120,
    name: 'Paint and Wallpaper Stores',
  },
  {
    code: 444130,
    name: 'Hardware Stores',
  },
  {
    code: 444210,
    name: 'Outdoor Power Equipment Stores',
  },
  {
    code: 445110,
    name: 'Supermarkets and Other Grocery (except Convenience) Stores',
  },
  {
    code: 445210,
    name: 'Meat Markets',
  },
  {
    code: 445230,
    name: 'Fruit and Vegetable Markets',
  },
  {
    code: 445299,
    name: 'All Other Specialty Food Stores',
  },
  {
    code: 445310,
    name: 'Beer, Wine, and Liquor Stores',
  },
  {
    code: 446110,
    name: 'Pharmacies and Drug Stores',
  },
  {
    code: 448110,
    name: "Men's Clothing Stores",
  },
  {
    code: 448120,
    name: "Women's Clothing Stores",
  },
  {
    code: 448130,
    name: "Children's and Infants' Clothing Stores",
  },
  {
    code: 448140,
    name: 'Family Clothing Stores',
  },
  {
    code: 448150,
    name: 'Clothing Accessories Stores',
  },
  {
    code: 448210,
    name: 'Shoe Stores',
  },
  {
    code: 448310,
    name: 'Jewelry Stores',
  },
  {
    code: 448320,
    name: 'Luggage and Leather Goods Stores',
  },
  {
    code: 451110,
    name: 'Sporting Goods Stores',
  },
  {
    code: 451120,
    name: 'Hobby, Toy, and Game Stores',
  },
  {
    code: 451130,
    name: 'Sewing, Needlework, and Piece Goods Stores',
  },
  {
    code: 451140,
    name: 'Musical Instrument and Supplies Stores',
  },
  {
    code: 451211,
    name: 'Book Stores',
  },
  {
    code: 451212,
    name: 'News Dealers and Newsstands',
  },
  {
    code: 451220,
    name: 'Prerecorded Tape, Compact Disc, and Record Stores',
  },
  {
    code: 452111,
    name: 'Department Stores (except Discount Department Stores)',
  },
  {
    code: 452910,
    name: 'Warehouse Clubs and Supercenters',
  },
  {
    code: 452990,
    name: 'All Other General Merchandise Stores',
  },
  {
    code: 453110,
    name: 'Florists',
  },
  {
    code: 453210,
    name: 'Office Supplies and Stationary Stores',
  },
  {
    code: 453220,
    name: 'Gift, Novelty, and Souvenir Stores',
  },
  {
    code: 453310,
    name: 'Used Merchandise Stores',
  },
  {
    code: 453930,
    name: 'Manufactured (Mobile) Home Dealers',
  },
  {
    code: 453991,
    name: 'Tobacco Stores',
  },
  {
    code: 454111,
    name: 'Electronic Shopping',
  },
  {
    code: 454210,
    name: 'Vending Machine Operators',
  },
  {
    code: 454390,
    name: 'Other Direct Selling Establishments',
  },
  {
    code: 481219,
    name: 'Other Nonscheduled Air Transportation',
  },
  {
    code: 485310,
    name: 'Taxi Service',
  },
  {
    code: 487110,
    name: 'Scenic and Sightseeing Transportation, Land',
  },
  {
    code: 488111,
    name: 'Air Traffic Control',
  },
  {
    code: 488210,
    name: 'Support Activities for Rail Transportation',
  },
  {
    code: 488390,
    name: 'Other Support Activities for Water Transportation',
  },
  {
    code: 488410,
    name: 'Motor Vehicle Towing',
  },
  {
    code: 488510,
    name: 'Freight Transportation Arrangement',
  },
  {
    code: 488991,
    name: 'Packing and Crating',
  },
  {
    code: 488999,
    name: 'All Other Support Activities for Transportation',
  },
  {
    code: 511110,
    name: 'Newspaper Publishers',
  },
  {
    code: 511120,
    name: 'Periodical Publishers',
  },
  {
    code: 511130,
    name: ' Book Publishers',
  },
  {
    code: 511140,
    name: 'Directory and Mailing List Publishers',
  },
  {
    code: 512110,
    name: 'Motion Picture and Video Production',
  },
  {
    code: 512120,
    name: 'Motion Picture and Video Distribution',
  },
  {
    code: 512131,
    name: 'Motion Picture Theaters (except Drive-Ins)',
  },
  {
    code: 512132,
    name: 'Drive-In Motion Picture Theaters',
  },
  {
    code: 512210,
    name: 'Record Production ',
  },
  {
    code: 512290,
    name: 'Other Sound Recording Industries',
  },
  {
    code: 515111,
    name: 'Radio Networks',
  },
  {
    code: 515120,
    name: 'Television Broadcasting ',
  },
  {
    code: 515210,
    name: 'Cable and Other Subscription Programming',
  },
  {
    code: 517110,
    name: 'Wired Telecommunications Carriers',
  },
  {
    code: 517211,
    name: 'Paging',
  },
  {
    code: 518111,
    name: 'Internet Service Providers',
  },
  {
    code: 518210,
    name: 'Data Processing, Hosting, and Related Services ',
  },
  {
    code: 519110,
    name: 'News Syndicates',
  },
  {
    code: 519120,
    name: 'Libraries and Archives',
  },
  {
    code: 521110,
    name: 'Monetary Authorities - Central Bank',
  },
  {
    code: 522110,
    name: 'Commercial Banking',
  },
  {
    code: 522120,
    name: 'Savings Institutions',
  },
  {
    code: 522130,
    name: 'Credit Unions',
  },
  {
    code: 522210,
    name: 'Credit Card Issuing',
  },
  {
    code: 522220,
    name: 'Sales Financing',
  },
  {
    code: 522292,
    name: 'Real Estate Credit',
  },
  {
    code: 522293,
    name: 'International Trade Financing',
  },
  {
    code: 522298,
    name: 'All Other Nondepository Credit Intermediation',
  },
  {
    code: 522310,
    name: 'Mortgage and Nonmortgage Loan Brokers',
  },
  {
    code: 522320,
    name: 'Financial Transactions Processing, Reserve, and Clearinghouse Activities',
  },
  {
    code: 523110,
    name: 'Investment Banking and Securities Dealing',
  },
  {
    code: 523130,
    name: 'Commodity Contracts Dealing',
  },
  {
    code: 523210,
    name: 'Securities and Commodity Exchanges',
  },
  {
    code: 523910,
    name: 'Miscellaneous Intermediation',
  },
  {
    code: 523920,
    name: 'Portfolio Management',
  },
  {
    code: 523991,
    name: 'Trust, Fiduciary, and Custody Activities',
  },
  {
    code: 524113,
    name: 'Direct Life Insurance Carriers',
  },
  {
    code: 524114,
    name: 'Direct Health and Medical Insurance Carriers',
  },
  {
    code: 524126,
    name: 'Direct Property and Casualty Insurance Carriers',
  },
  {
    code: 524127,
    name: 'Direct Title Insurance Carriers',
  },
  {
    code: 524128,
    name: 'Other Direct Insurance (except Life, Health, and Medical) Carriers',
  },
  {
    code: 524210,
    name: 'Insurance Agencies and Brokerages',
  },
  {
    code: 525910,
    name: 'Open-End Investment Funds',
  },
  {
    code: 525930,
    name: 'Real Estate Investment Trusts',
  },
  {
    code: 525990,
    name: 'Other Financial Vehicles',
  },
  {
    code: 531110,
    name: 'Lessors of Residential Buildings and Dwellings',
  },
  {
    code: 531120,
    name: 'Lessors of Nonresidential Buildings (except Miniwarehouses)',
  },
  {
    code: 531190,
    name: 'Lessors of Other Real Estate Property',
  },
  {
    code: 532111,
    name: 'Passenger Car Rental',
  },
  {
    code: 532112,
    name: 'Passenger Car Leasing',
  },
  {
    code: 532120,
    name: 'Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing',
  },
  {
    code: 532210,
    name: 'Consumer Electronics and Appliances Rental',
  },
  {
    code: 532220,
    name: 'Formal Wear and Costume Rental',
  },
  {
    code: 532230,
    name: 'Video Tape and Disc Rental',
  },
  {
    code: 532291,
    name: 'Home Health Equipment Rental',
  },
  {
    code: 532420,
    name: 'Office Machinery and Equipment Rental and Leasing',
  },
  {
    code: 533110,
    name: 'Lessors of Nonfinancial Intangible Assets (except Copyrighted Works) ',
  },
  {
    code: 541110,
    name: 'Offices of Lawyers ',
  },
  {
    code: 541191,
    name: 'Title Abstract and Settlement Offices',
  },
  {
    code: 541211,
    name: 'Offices of Certified Public Accountants',
  },
  {
    code: 541213,
    name: 'Tax Preparation Services',
  },
  {
    code: 541310,
    name: 'Architectural Services',
  },
  {
    code: 541320,
    name: 'Landscape Architectural Services',
  },
  {
    code: 541330,
    name: 'Engineering Services',
  },
  {
    code: 541360,
    name: 'Geophysical Surveying and Mapping Services',
  },
  {
    code: 541380,
    name: 'Testing Laboratories',
  },
  {
    code: 541430,
    name: 'Graphic Design Services',
  },
  {
    code: 541511,
    name: 'Custom Computer Programming Services',
  },
  {
    code: 541512,
    name: 'Computer Systems Design Services',
  },
  {
    code: 541513,
    name: 'Computer Facilities Management Services',
  },
  {
    code: 541611,
    name: 'Administrative Management and General Management Consulting Services',
  },
  {
    code: 541612,
    name: 'Human Resources and Executive Search Consulting Services',
  },
  {
    code: 541710,
    name: 'Research and Development in the Physical, Engineering, and Life Sciences',
  },
  {
    code: 541720,
    name: 'Research and Development in the Social Sciences and Humanities',
  },
  {
    code: 541810,
    name: 'Advertising Agencies',
  },
  {
    code: 541820,
    name: 'Public Relations Agencies',
  },
  {
    code: 541840,
    name: 'Media Representatives',
  },
  {
    code: 541850,
    name: 'Display Advertising',
  },
  {
    code: 541921,
    name: 'Photography Studios, Portrait',
  },
  {
    code: 551111,
    name: 'Offices of  Bank Holding Companies',
  },
  {
    code: 551112,
    name: 'Offices of  Other Holding Companies',
  },
  {
    code: 561210,
    name: 'Facilities Support Services',
  },
  {
    code: 561320,
    name: 'Temporary Help Services',
  },
  {
    code: 561410,
    name: 'Document Preparation Services',
  },
  {
    code: 561440,
    name: 'Collection Agencies',
  },
  {
    code: 561450,
    name: ' Credit Bureaus',
  },
  {
    code: 561510,
    name: 'Travel Agencies',
  },
  {
    code: 561520,
    name: 'Tour Operators',
  },
  {
    code: 561740,
    name: 'Carpet and Upholstery Cleaning Services',
  },
  {
    code: 611110,
    name: 'Elementary and Secondary Schools',
  },
  {
    code: 611210,
    name: 'Junior Colleges',
  },
  {
    code: 611310,
    name: 'Colleges, Universities, and Professional Schools',
  },
  {
    code: 611410,
    name: 'Business and Secretarial Schools',
  },
  {
    code: 611420,
    name: 'Computer Training ',
  },
  {
    code: 611430,
    name: 'Professional and Management Development Training',
  },
  {
    code: 611511,
    name: 'Cosmetology and Barber Schools',
  },
  {
    code: 611512,
    name: 'Flight Training',
  },
  {
    code: 611610,
    name: 'Fine Arts Schools',
  },
  {
    code: 621111,
    name: 'Offices of Physicians (except Mental Health Specialists)',
  },
  {
    code: 621210,
    name: 'Offices of Dentists',
  },
  {
    code: 621310,
    name: 'Offices of Chiropractors',
  },
  {
    code: 621320,
    name: 'Offices of Optometrists',
  },
  {
    code: 621330,
    name: 'Offices of Mental Health Practitioners (except Physicians)',
  },
  {
    code: 621391,
    name: 'Offices of Podiatrists',
  },
  {
    code: 621399,
    name: 'Offices of All Other Miscellaneous Health Practitioners',
  },
  {
    code: 621492,
    name: 'Kidney Dialysis Centers',
  },
  {
    code: 621511,
    name: 'Medical Laboratories',
  },
  {
    code: 621610,
    name: 'Home Health Care Services',
  },
  {
    code: 622110,
    name: 'General Medical and Surgical Hospitals',
  },
  {
    code: 622210,
    name: 'Psychiatric and Substance Abuse Hospitals',
  },
  {
    code: 623110,
    name: 'Nursing Care Facilities',
  },
  {
    code: 623210,
    name: 'Residential Mental Retardation Facilities',
  },
  {
    code: 624110,
    name: 'Child and Youth Services',
  },
  {
    code: 624310,
    name: 'Vocational Rehabilitation Services',
  },
  {
    code: 624410,
    name: 'Child Day Care Services',
  },
  {
    code: 711110,
    name: 'Theater Companies and Dinner Theaters',
  },
  {
    code: 711130,
    name: 'Musical Groups and Artists',
  },
  {
    code: 712110,
    name: 'Museums',
  },
  {
    code: 712130,
    name: 'Zoos and Botanical Gardens',
  },
  {
    code: 713110,
    name: 'Amusement and Theme Parks',
  },
  {
    code: 713120,
    name: 'Amusement Arcades',
  },
  {
    code: 713910,
    name: 'Golf Courses and Country Clubs',
  },
  {
    code: 713940,
    name: 'Fitness and Recreational Sports Centers',
  },
  {
    code: 713950,
    name: 'Bowling Centers',
  },
  {
    code: 721110,
    name: 'Hotels (except Casino Hotels) and Motels',
  },
  {
    code: 721211,
    name: 'RV (Recreational Vehicle) Parks and Campgrounds',
  },
  {
    code: 721214,
    name: 'Recreational and Vacation Camps (except Campgrounds)',
  },
  {
    code: 721310,
    name: 'Rooming and Boarding Houses',
  },
  {
    code: 722410,
    name: 'Drinking Places (Alcoholic Beverages)',
  },
  {
    code: 811111,
    name: 'General Automotive Repair',
  },
  {
    code: 811112,
    name: 'Automotive Exhaust System Repair',
  },
  {
    code: 811113,
    name: 'Automotive Transmission Repair',
  },
  {
    code: 811118,
    name: 'Other Automotive Mechanical and Electrical Repair and Maintenance',
  },
  {
    code: 811121,
    name: 'Automotive Body, Paint, and Interior Repair and Maintenance ',
  },
  {
    code: 811122,
    name: 'Automotive Glass Replacement Shops',
  },
  {
    code: 811192,
    name: 'Car Washes',
  },
  {
    code: 811310,
    name: 'Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance',
  },
  {
    code: 811420,
    name: 'Reupholstery and Furniture Repair',
  },
  {
    code: 811430,
    name: 'Footwear and Leather Goods Repair',
  },
  {
    code: 811490,
    name: 'Other Personal and Household Goods Repair and Maintenance',
  },
  {
    code: 812210,
    name: 'Funeral Homes and Funeral Services',
  },
  {
    code: 812220,
    name: 'Cemeteries and Crematories',
  },
  {
    code: 812310,
    name: 'Coin-Operated Laundries and Drycleaners',
  },
  {
    code: 812320,
    name: 'Drycleaning and Laundry Services (except Coin-Operated)',
  },
  {
    code: 812331,
    name: 'Linen Supply',
  },
  {
    code: 812332,
    name: 'Industrial Launderers',
  },
  {
    code: 812921,
    name: 'Photofinishing Laboratories (except One-Hour)',
  },
  {
    code: 812930,
    name: 'Parking Lots and Garages',
  },
  {
    code: 813211,
    name: 'Grantmaking Foundations',
  },
  {
    code: 813212,
    name: 'Voluntary Health Organizations',
  },
  {
    code: 814110,
    name: 'Private Households',
  },
  {
    code: 921110,
    name: 'Executive Offices',
  },
  {
    code: 921120,
    name: 'Legislative Bodies',
  },
  {
    code: 921130,
    name: 'Public Finance Activities',
  },
  {
    code: 921140,
    name: 'Executive and Legislative Offices, Combined ',
  },
  {
    code: 921190,
    name: 'Other General Government Support',
  },
  {
    code: 922110,
    name: 'Courts',
  },
  {
    code: 922130,
    name: 'Legal Counsel and Prosecution',
  },
  {
    code: 923110,
    name: 'Administration of Education Programs',
  },
  {
    code: 923120,
    name: 'Administration of Public Health Programs',
  },
  {
    code: 923130,
    name: 'Administration of Human Resource Programs (except Education, Public Health, and Veteran’s Affairs Programs)',
  },
  {
    code: 923140,
    name: 'Administration of Veteran’s Affairs',
  },
  {
    code: 925110,
    name: 'Administration of Housing Programs',
  },
  {
    code: 925120,
    name: 'Administration of Urban Planning and Community and Rural Development',
  },
  {
    code: 926110,
    name: 'Administration of General Economic Programs',
  },
  {
    code: 926130,
    name: 'Regulation and Administration of Communications, Electric, Gas, and Other Utilities',
  },
  {
    code: 926140,
    name: 'Regulation of Agricultural Marketing and Commodities',
  },
  {
    code: 926150,
    name: 'Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors',
  },
];
